
























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import HintsContainer from '@/components/HintsContainer.vue';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ResultView from '@/components/ResultView.vue';
import SideToolbar from '@/components/SideToolbar.vue';
import {Generators, TableHeaders} from '@/interfaces/components-data';
import DatePicker from 'vue2-datepicker';
import moment, { Moment } from 'moment';
import {isNumber} from "lodash";
import ModuleApi from "@/pages/ModuleItems/ModuleApi";

import {
    CalcIndividualConfig,
    Coefficents,
    ConfigMap,
    FindFiltersParams,
    IndividualConfig,
    PromoIndividualConfig,
    PromotionIndividualConfig,
    Promotions,
    PromotionsServerIndividualConfig,
    PromoType,
    SaleIndividualConfig,
    Sales,
    SaleServerIndividualConfig,
    SelectBox,
    StrategyOfPriceOpt,
    TaskInfoCalc,
} from '@/interfaces/global-data';
import {
    BaseFilterRoundingRules,
    CompetitorsPriceFilter,
    CompetitorsPricesView,
    GetTaskInfo,
    IErrors,
    InternalCodeAndProductRange,
    KviStrategies,
    NewProductPriceStrategy,
    PackagePromoConfig,
    ProductInfoResponseProperty,
    ProductSegmentIdAndName,
    PromoFilterProducts,
    PromoFilterType,
    Segment,
    Sku,
    SkuFilter,
    TaskAndFile,
    SaveModuleItemParamsFilter,
    ModuleItemCalculationStartParams,
    ModuleItemFilters,
    TaskInfoFilterType,
} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import LocalData, {ErrorsMap} from '@/mixins/local-data';
import {FormatNumber} from '@/numberFormatter';
import { Formatter } from '@/helpers/formatters';
import {BTabs} from 'bootstrap-vue';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import Toast from '@/mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"
import Card from '@/components/UI/Card.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import {
    IModuleItem,
    IModuleItemResponseDto,
    IModuleItemSaveDto,
    TModuleType,
    EntityMaskOptions,
    TaskTypeEntityProperties,
    EntityFilters,
    EntityFilterKeys,
} from "@/pages/ModuleItems/data";
import Vue from "vue";


@Component({
    computed: {
        moment() {
          return moment;
        },
        PromoFilterType() {
            return PromoFilterType;
        },
        PromoFilterProducts() {
            return PromoFilterProducts;
        },
        TaskInfoFilterType() {
            return TaskInfoFilterType;
        }
    },
    components: {
        ResultView,
        SideToolbar,
        MultiSelect,
        MarketSelect,
        vSelect,
        HintsContainer,
        DatePicker,
        CollapseCard,
        Card,
        CSelect,
        SwitchWithLabel,
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD.MM.YYYY');
            }
        },
        formatRulesDate: (v: any) => {
            if (v) {
                return moment(moment.utc(v)).local().format('DD/MM/YYYY HH:mm:ss');
            }
        },
        formatCompetitorsDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('YYYY-MM-DD');
            }
        },
    },
    methods: {
        changeRowColor(item) {
            if (item !== null) {
                const index = this.$data.promoInternalCodesFromPromoFile.findIndex((v: string) => {
                    return v === item.internalCode;
                });
                if (index !== -1) {
                    return 'table-warning';
                }
            }
        },
        changeRowColorInDetailReport(item) {
            if (item !== null) {
                if (item.kvi === 'ДА') {
                    return 'table-primary';
                }
                if (item.resultType === 'COMPETITOR') {
                    return 'table-danger';
                }
            }
        },
        formatNumber(number) {
            if (String(number)[0] === '-') {
                return String(number).substring(0, 4);
            } else {
                return String(number).substring(0, 3);
            }
        },
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },
        replaceDecimalFormatter(value) {
            if (value == null) {
                return null
            } else {
                return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
            }
        },
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '').substring(0, 2);
            }
        },
        replaceTxtToNumberForRoundingRules(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '');
            }
        },
        isNumber,
    },
})
export default class Parameters extends Mixins(Toast, Http, LocalData) {
    @Prop() readonly moduleType!: TModuleType;
    @Prop({required: false}) readonly currentItem: IModuleItemResponseDto = {} as IModuleItemResponseDto;
    @Prop({required: true}) readonly errObj: any;

    @Watch('currentItem', {deep: true})
    onCurrentItemChanged(currentItem: IModuleItemResponseDto, oldValue: IModuleItemResponseDto) {
        if (currentItem.id !== this.itemToEdit.id) {
            this.itemToEdit = Object.assign({}, this.currentItem);

            this.entityFilters.groupIds = this.itemToEdit.groups.map(el => el.id);
            this.entityFilters.categoryIds = this.itemToEdit.categories.map(el => el.id);
            this.entityFilters.subcategoryId = this.itemToEdit.subcategory ? this.itemToEdit.subcategory.id : 0;
            this.entityFilters.formatId = this.itemToEdit.format ? this.itemToEdit.format.id : 0;
            this.entityFilters.regionIds = this.itemToEdit.regions.map(el => el.id);
            this.entityFilters.clusterIds = this.itemToEdit.clusters.map(el => el.id);

            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.group, 'entityGroupsSelectRef');
            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.category, 'entityCategoriesSelectRef');
            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.subcategory, 'entitySubcategorySelectRef');
            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionsSelectRef');
            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');

            this.tryFindParams();
        }
    }

  get calculationTypeValue() {
    // return raw value string or undefined
    const ct = (this.moduleData as any).calculationType;
    return ct && ct.value ? ct.value : ct;
  }

  set calculationTypeValue(value: string) {
    if (this.moduleType === 'promo') {
      const labels = {
        'standard': this.$t('shared.parametersTab.standard') as string,
        'ml': this.$t('shared.parametersTab.advanced') as string
      };
      (this.moduleData as any).calculationType = { value, label: labels[value as keyof typeof labels] };
    }
  }

  onCalculationTypeChange(value: string) {
    this.calculationTypeValue = value;
    this.saveModuleItems();
  }

    @Watch('errObj', {deep: true})
    onErrObjChanged() {
        if (this.errObj) {
            this.handleHttpError(this.errObj);
        } else {
            this.hideFormErrors('updateItem');
        }
    }

    @Watch('itemToEdit.startDate', {deep: true})
    @Watch('itemToEdit.endDate', {deep: true})
    @Watch('itemToEdit.stagesNumber', {deep: true})
    setItemsCalculationDay() {
        if (this.itemToEdit.startDate && this.itemToEdit.endDate && this.itemToEdit.stagesNumber) {
            const dateDiff: number = +new Date(this.itemToEdit.endDate) - +new Date(this.itemToEdit.startDate);

            if (dateDiff > 0) {
                const resValue: number = Math.floor(dateDiff / 84600000 / this.itemToEdit.stagesNumber);

                this.moduleData.calculationDay = resValue >= 1 ? resValue : 1;

                if (!!this.periodForCalculatingEntered) {
                    this.periodForCalculatingEntered = null;
                }
            }
        }
    }

    get moduleData(): Sales | Promotions {
        if (this.moduleType === 'promo') {
            return this.$promotions as Promotions;
        } else {
            return this.$sales as Sales;
        }
    }

    set moduleData(data: Sales | Promotions) {
        if (this.moduleType === 'promo') {
            this.$promotions = data as Promotions;
        } else {
            this.$sales = data as Sales;
        }
    }

    get saveModuleItems() {
        if (this.moduleType === 'promo') {
            return this.savePromotions;
        } else {
            return this.saveSales;
        }
    }

    parametersTabsHeight: string = '100%';

    entityFilters: EntityFilters = {
        groupIds: [],
        categoryIds: [],
        subcategoryId: null,
        formatId: null,
        regionIds: [],
        clusterIds: [],
    };

    itemToEdit: IModuleItemResponseDto = {
        id: null,
        startDate: null,
        endDate: null,
        name: null,
        type: null,
        status: null,
        stagesNumber: null,
        minSaleDiscount: null,
        maxSaleDiscount: null,
        minPromotionDiscount: null,
        maxPromotionDiscount: null,
        minMargin: null,
        tradingId: null,
        groups: [{
            id: 0,
            name: ''
        }],
        categories: [{
            id: 0,
            name: ''
        }],
        subcategory: {
            id: 0,
            name: ''
        },
        format: {
            id: 0,
            name: ''
        },
        regions: [{
            id: 0,
            name: ''
        }],
        clusters: [{
            id: 0,
            name: ''
        }],
        skuCount: null,
        remains: null,
        taskId: null,
        revaluationFileName: null,
    };

    private periodForCalculatingEntered: string | number | null = null;

    private showFormError: boolean = false;
    private formErrors: ErrorsMap = {};

    file: File | null = null;
    productLineOptions: Array<SelectBox<string>> = [];
    productLineOptionsForFilter: Array<SelectBox<string>> = [];
    selectProductLine: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;

    productRangesArray: InternalCodeAndProductRange[] = [];

    defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};
    secondDefaultFilterValue = {value: -2, label: this.$t('shared.selectBox.empty') as string};

    selectProducts: PromoFilterProducts = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string}.value;
    selectProductsTypeForRecommends: PromoFilterProducts = PromoFilterProducts.ALL;
    selectProductsForPiRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string};
    selectProductsForCdRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string};
    selectProductsForIgRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string};
    productFilterOptions: Array<SelectBox<PromoFilterProducts>> = [
        {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string},
        {value: PromoFilterProducts.PROMO, label: this.$t('shared.selectBox.promo') as string},
        {value: PromoFilterProducts.REGULAR, label: this.$t('shared.selectBox.regular') as string},
    ];

    selectKVI: number = this.defaultFilterValue.value;
    selectKVIForNewProducts: number = this.defaultFilterValue.value;
    selectKVIRecommends: number = this.defaultFilterValue.value;
    kviValueForRecommends: number = -1;
    selectKVIForPiRecommends: SelectBox<number> = this.defaultFilterValue;
    selectKVIForCdRecommends: SelectBox<number> = this.defaultFilterValue;
    selectKVIForIgRecommends: SelectBox<number> = this.defaultFilterValue;
    kviOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 1, label: 'KVI'},
        {value: 0, label: this.$t('shared.selectBox.notKvi') as string},
    ];

    kviRecommendsOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 0, label: this.$t('shared.selectBox.gk') as string},
        {value: 1, label: this.$t('shared.selectBox.cvk') as string},
    ];

    selectCTM: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
    selectCTMForNewProducts: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
    ctmValueForRecommends: string | null = null;
    selectCTMForPiRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    selectCTMForCdRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    selectCTMForIgRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    ctmOptions: Array<SelectBox<string>> = [
        {value: 'all', label: this.$t('shared.selectBox.all') as string},
        {value: '1', label: 'CTM'},
        {value: '0', label: this.$t('shared.selectBox.notCtm') as string},
    ];

    selectSegmentPrice: Segment[] = [];
    selectSegmentPriceForNewProducts: Segment[] = [];
    segmentPriceValueForRecommends: Segment[] = [];
    selectPiRecommendsSegmentPrice: Segment[] = [];
    selectCdRecommendsSegmentPrice: Segment[] = [];
    selectIgRecommendsSegmentPrice: Segment[] = [];
    segmentPriceOptions: Array<SelectBox<Segment>> = [];
    segmentPriceOptionsForNewProducts: Array<SelectBox<Segment>> = [];
    segmentPriceForRecommendsOptions: Array<SelectBox<Segment>> = [];
    selectProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    selectNewProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    newProductSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    productSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    tableKey = 1;
    competitorTableKey = 1;

    selectKeyCharacteristicOne: string[] = [];
    selectKeyCharacteristicTwo: string[] = [];
    selectRecipeAttributes: string[] = [];
    selectTreatmentAttributes: number[] = [];

    selectKeyCharacteristicOneForNewProduct: string[] = [];
    selectKeyCharacteristicTwoForNewProduct: string[] = [];
    selectRecipeAttributesForNewProduct: string[] = [];
    selectTreatmentAttributesForNewProduct: number[] = [];

    keyCharacteristicOneOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoOptions: Array<SelectBox<string>> = [];
    recipeAttributesOptions: Array<SelectBox<string>> = [];
    treatmentAttributesOptions: Array<SelectBox<number>> = [];

    keyCharacteristicOneForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoForNewProductOptions: Array<SelectBox<string>> = [];
    recipeAttributesForNewProductOptions: Array<SelectBox<string>> = [];
    treatmentAttributesForNewProductOptions: Array<SelectBox<number>> = [];

    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };
    taskInfoRecommends: TaskInfoCalc = {
        storeFormatOptions: [],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [],
        clusterOptions: [],
        groupsOfProduct: [],
        subcategories: [],
        subcategoriesDefault: [],
        psegemnts: [],
    };

    entityMaskOptions: EntityMaskOptions = {
        groups: [],
        categories: [],
        subcategories: [],
        formats: [],
        regions: [],
        clusters: [],
    };

    entityMaskOptionPropertyNames: TaskTypeEntityProperties = {
        group: 'groups',
        category: 'categories',
        subcategory: 'subcategories',
        format: 'formats',
        region: 'regions',
        cluster: 'clusters',
    }

    entityFiltersPropertyNames: TaskTypeEntityProperties = {
        group: 'groupIds',
        category: 'categoryIds',
        subcategory: 'subcategoryId',
        format: 'formatId',
        region: 'regionIds',
        cluster: 'clusterIds',
    }

    promoSkuOfferRunning: boolean = false;
    searchable: boolean = true;
    usePromoRecommendsFilter: boolean = false;
    skuFilter: string = '';
    newProductsFilter: string = '';
    skuRecommendsFilter: string = '';
    skuList: Sku[] = [];
    skuListWithAllProducts: Sku[] = [];
    newProductsList: Sku[] = [];
    newProductsListWithAllProducts: Sku[] = [];
    fileResult: string = '';
    taskId: number = 0;
    trafficGenerators: Generators[] = [];
    incomeGenerators: Generators[] = [];
    cartDrivers: Generators[] = [];
    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
    promoFilter: Array<SelectBox<PromoFilterType>> = [
        {value: PromoFilterType.all, label: this.$t('shared.selectBox.all') as string},
        {value: PromoFilterType.ig, label: this.$t('shared.selectBox.revenueGenerator') as string},
        {value: PromoFilterType.cd, label: this.$t('shared.selectBox.cartDriver') as string},
        {value: PromoFilterType.pi, label: this.$t('shared.selectBox.penetrationIndex') as string},
    ];
    selectedPromoFilter: PromoFilterType = {value: PromoFilterType.all, label: this.$t('shared.selectBox.all') as string}.value;
    recommendsType: PromoFilterType = PromoFilterType.pi;
    skuListLimit: number = 20;
    newProductsListLimit: number = 20;
    isNeedSaveParamsBeforeStartCalc: boolean = false;
    isCalculationButtonLoading: boolean = false;

    competitorsTable: any[] = [
        {
            dataIndex: 'selected',
            title: '✓',
            scopedSlots: { customRender: 'selected' },
            width: 70,
            fixed: 'left',
        },
        {
            dataIndex: 'internalCode',
            title: this.$t('results.tableHeaders.internalCode') as string,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'skuName',
            title: 'SKU',
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'lastPrice',
            title: this.$t('results.tableHeaders.lastPrice') as string,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'minCompetitorPrice',
            title: this.$t('results.tableHeaders.minCompetitorPrice') as string,
            customRender: (value: any) => `${this.numberFormatter(value.price)} (${value.name})`,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'maxCompetitorPrice',
            title: this.$t('results.tableHeaders.maxCompetitorPrice') as string,
            customRender: (value: any) => `${this.numberFormatter(value.price)} (${value.name})`,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'avgCompetitorPrices',
            title: this.$t('results.tableHeaders.avgCompetitorPrice') as string,
            customRender: (value: any) => this.numberFormatter(value.price),
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'lastPromoCompetitorPrice',
            title: this.$t('results.tableHeaders.lastPromoPrice') as string,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'minPromoCompetitorPrice',
            title: this.$t('results.tableHeaders.minPromoPrice') as string,
            customRender: (value: any) => value ? `${this.numberFormatter(value.price)} (${value.name})` : '',
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'maxPromoCompetitorPrice',
            title: this.$t('results.tableHeaders.maxPromoPrice') as string,
            customRender: (value: any) => value ? `${this.numberFormatter(value.price)} (${value.name})` : '',
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'medianPromoCompetitorPrice',
            title: this.$t('results.tableHeaders.medianPromoPrice') as string,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'kvi',
            title: 'KVI',
            customRender: (value: any) => value === 1 ? this.$t('shared.labels.yes') as string : this.$t('shared.labels.no') as string,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'maxCompetitorsDate',
            title: this.$t('competitorsPricesList.tableHeaders.monitoringDate') as string,
            customRender: (value: any) => moment(new Date(+value)).format('YYYY-MM-DD'),
            width: 150,
            ellipsis: true,
        },
    ];

    taskData: TaskAndFile | null = null;

    competitors: CompetitorsPricesView[] = [];

    tableFields: TableHeaders[] = [
        {key: 'selected', label: ''},
        {key: 'internalCode', label: this.$t('results.tableHeaders.internalCode') as string},
        {key: 'productSegmentName', label: this.$t('results.tableHeaders.productSegment') as string},
        {key: 'skuName', label: 'SKU'},
        {key: 'tags', label: ''},
        {key: 'keyCharacteristicOfTheProductIsOne', label: this.$t('results.tableHeaders.kht1') as string},
        {key: 'keyCharacteristicOfTheProductIsTwo', label: this.$t('results.tableHeaders.kht2') as string},
        {key: 'recipeAttribute', label: this.$t('results.tableHeaders.prc') as string},
        {key: 'treatmentAttribute', label: this.$t('results.tableHeaders.pkl') as string},
        {key: 'promoType', label: this.$t('results.tableHeaders.promoType') as string},
        {key: 'lift', label: this.$t('shared.parametersTab.regularPriceCorrection') as string},
        {key: 'kvi', label: 'KVI'},
        {key: 'tagsKvi', label: ''},
        {key: 'ctm', label: 'CTM'},
        {key: 'minMaxRetailPrice', label: this.$t('results.tableHeaders.minMaxRc') as string},
        {key: 'productRange', label: this.$t('results.tableHeaders.line') as string},
        {key: 'lastPrice', label: this.$t('shared.labels.lastPrice') as string},
        {key: 'priceSegment', label: this.$t('results.tableHeaders.priceSegment') as string},
        {key: 'lastPriceMarginPc', label: this.$t('results.tableHeaders.marginLastPrice') as string},
        {key: 'actualProfitability', label: this.$t('shared.labels.actualProfitability') as string},
        {key: 'purchasePriceAvgM', label: this.$t('results.tableHeaders.avgPurchasePrice') as string},
        {key: 'purchasePrice', label: this.$t('results.tableHeaders.promoPurchasePrice') as string},
        {key: 'coefficentList', label: this.$t('results.tableHeaders.priceOptStrategy') as string},
        {key: 'priceIncreaseLimit', label: this.$t('results.tableHeaders.increaseLimit') as string},
        {key: 'periodPriceIncreaseLimit', label: this.$t('results.tableHeaders.periodPriceIncreaseLimit') as string},
        {key: 'period', label: this.$t('results.tableHeaders.period') as string},
        {key: 'marginalProfit', label: this.$t('results.tableHeaders.minMarginSku') as string},
        {key: 'maxMarginalProfit', label: this.$t('results.tableHeaders.maxMarginSku') as string},
        {key: 'kviStrategy', label: this.$t('results.tableHeaders.kviStrategy') as string},
        {key: 'percentageOfCompetitorsPrice', label: this.$t('results.tableHeaders.correction') as string},
    ];

    newTableFields: any[] = [
        {dataIndex: 'selected', title: '✓', scopedSlots: { customRender: 'selected', filterDropdown: 'selectedFilter', filterIcon: 'selectedFilterIcon' }, width: 60},
        {dataIndex: 'internalCode', title: this.$t('results.tableHeaders.internalCode') as string, width: 110, ellipsis: true},
        {dataIndex: 'productSegmentName', title: this.$t('results.tableHeaders.productSegment') as string, width: 150, ellipsis: true, scopedSlots: { filterDropdown: 'productSegmentNameFilter', filterIcon: 'productSegmentNameFilterIcon'}},
        {dataIndex: 'skuName', width: 170, ellipsis: true, scopedSlots: { title: 'sku', filterDropdown: 'skuFilter', filterIcon: 'skuFilterIcon' }},
        {dataIndex: 'tags', title: '', width: 100, scopedSlots: { customRender: 'tags' }},
        {dataIndex: 'keyCharacteristicOfTheProductIsOne', title: this.$t('results.tableHeaders.kht1') as string, width: 150, ellipsis: true, scopedSlots: { filterDropdown: 'kxt1Filter', filterIcon: 'kxt1FilterIcon' }},
        {dataIndex: 'keyCharacteristicOfTheProductIsTwo', title: this.$t('results.tableHeaders.kht2') as string, width: 150, ellipsis: true, scopedSlots: { filterDropdown: 'kxt2Filter', filterIcon: 'kxt2FilterIcon' }},
        {dataIndex: 'recipeAttribute', title: this.$t('results.tableHeaders.prc') as string, width: 150, ellipsis: true, scopedSlots: { filterDropdown: 'prcFilter', filterIcon: 'prcFilterIcon' }},
        {dataIndex: 'treatmentAttribute', title: this.$t('results.tableHeaders.pkl') as string, width: 150, ellipsis: true, scopedSlots: { filterDropdown: 'pklFilter', filterIcon: 'pklFilterIcon' }},
        {dataIndex: 'promoType', title: this.$t('results.tableHeaders.promoType') as string, scopedSlots: { customRender: 'promoType' }, width: 100},
        {dataIndex: 'lift', title: this.$t('shared.parametersTab.regularPriceCorrection') as string, scopedSlots: { customRender: 'lift' }, width: 130},
        {dataIndex: 'kvi', title: 'KVI', scopedSlots: { customRender: 'kvi', filterDropdown: 'kviFilter', filterIcon: 'kviFilterIcon' }, width: 50},
        {dataIndex: 'tagsKvi', title: '', scopedSlots: { customRender: 'tagsKvi', filterDropdown: 'tagsKviFilter', filterIcon: 'tagsKviFilterIcon' }, width: 100},
        {dataIndex: 'ctm', title: 'CTM', width: 70, ellipsis: true, scopedSlots: { filterDropdown: 'ctmFilter', filterIcon: 'ctmFilterIcon' }},
        {dataIndex: 'minMaxRetailPrice', title: this.$t('results.tableHeaders.minMaxRc') as string, scopedSlots: { customRender: 'minMaxRetailPrice' }, width: 100},
        {dataIndex: 'productRange', title: this.$t('results.tableHeaders.line') as string, scopedSlots: { customRender: 'productRange', filterDropdown: 'productRangeFilter', filterIcon: 'productRangeFilterIcon' }, width: 100},
        {dataIndex: 'lastPrice', scopedSlots: { customRender: 'lastPrice', title: 'lastPriceTitle' }, width: 100},
        {dataIndex: 'priceSegment', title: this.$t('results.tableHeaders.priceSegment') as string, scopedSlots: { customRender: 'priceSegment', filterDropdown: 'priceSegmentFilter', filterIcon: 'priceSegmentFilterIcon' }, width: 110},
        {dataIndex: 'lastPriceMarginPc', title: this.$t('results.tableHeaders.marginLastPrice') as string, width: 100},
        {dataIndex: 'actualProfitability', scopedSlots: { customRender: 'actualProfitability', title: 'actualProfitabilityTitle' }, width: 110},
        {dataIndex: 'purchasePriceAvgM', title: this.$t('results.tableHeaders.avgPurchasePrice') as string, scopedSlots: { customRender: 'purchasePriceAvgM' }, width: 70},
        {dataIndex: 'purchasePrice', title: this.$t('results.tableHeaders.promoPurchasePrice') as string, scopedSlots: { customRender: 'purchasePrice' }, width: 100},
        {dataIndex: 'coefficentList', title: this.$t('results.tableHeaders.priceOptStrategy') as string, scopedSlots: { customRender: 'coefficentList' }, width: 170},
        {dataIndex: 'priceIncreaseLimit', title: this.$t('results.tableHeaders.increaseLimit') as string, scopedSlots: { customRender: 'priceIncreaseLimit' }, width: 110},
        {dataIndex: 'periodPriceIncreaseLimit', title: this.$t('results.tableHeaders.periodPriceIncreaseLimit') as string, scopedSlots: { customRender: 'periodPriceIncreaseLimit' }, width: 150},
        {dataIndex: 'period', title: this.$t('results.tableHeaders.period') as string, scopedSlots: { customRender: 'period' }, width: 100},
        {dataIndex: 'marginalProfit', title: this.$t('results.tableHeaders.minMarginSku') as string, scopedSlots: { customRender: 'marginalProfit' }, width: 150},
        {dataIndex: 'maxMarginalProfit', title: this.$t('results.tableHeaders.maxMarginSku') as string, scopedSlots: { customRender: 'maxMarginalProfit' }, width: 150},
        {dataIndex: 'kviStrategy', title: this.$t('results.tableHeaders.kviStrategy') as string, scopedSlots: { customRender: 'kviStrategy' }, width: 150, ellipsis: true},
        {dataIndex: 'percentageOfCompetitorsPrice', title: this.$t('results.tableHeaders.correction') as string, scopedSlots: { customRender: 'percentageOfCompetitorsPrice' }, width: 150},
        {
          dataIndex: 'productVolume',
          title: this.$t('results.tableHeaders.productVolume') as string,
          customRender: (value: any) => this.numberFormatter(value),
          ellipsis: false,
          width: 40,
        },
        {
          dataIndex: 'measurementUnit',
          title: this.$t('results.tableHeaders.measurementUnit') as string,
          ellipsis: false,
          width: 30,
        },
        {
          dataIndex: 'productVerticalLine',
          title: this.$t('results.tableHeaders.productVerticalLine') as string,
          ellipsis: true,
          width: 70,
        },
        {
          dataIndex: 'isVerticalLineBase',
          title: this.$t('results.tableHeaders.isVerticalLineBase') as string,
          customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
          ellipsis: false,
          width: 50,
        },
        {
          dataIndex: 'vlStrategyStr',
          title: this.$t('results.tableHeaders.vlStrategyStr') as string,
          ellipsis: false,
          width: 70,
        },
        {
          dataIndex: 'vlGapPc',
          title: this.$t('results.tableHeaders.vlGapPc') as string,
          customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
          ellipsis: false,
          width: 70,
        },
    ];
    skuPagination: any = {
        pageSize: 20,
        current: 1,
    };
    newProductsPagination: any = {
        pageSize: 20,
        current: 1,
    };

    newProductsTableFields: TableHeaders[] = [
        {key: 'internalCode', label: this.$t('results.tableHeaders.internalCode') as string},
        {key: 'productSegmentName', label: this.$t('results.tableHeaders.productSegment') as string},
        {key: 'skuName', label: 'SKU'},
        {key: 'keyCharacteristicOfTheProductIsOne', label: this.$t('results.tableHeaders.kht1') as string},
        {key: 'keyCharacteristicOfTheProductIsTwo', label: this.$t('results.tableHeaders.kht2') as string},
        {key: 'recipeAttribute', label: this.$t('results.tableHeaders.prc') as string},
        {key: 'treatmentAttribute', label: this.$t('results.tableHeaders.pkl') as string},
        {key: 'promoType', label: this.$t('results.tableHeaders.promoType') as string},
        {key: 'lift', label: this.$t('shared.parametersTab.regularPriceCorrection') as string},
        {key: 'kvi', label: 'KVI'},
        {key: 'ctm', label: 'CTM'},
        {key: 'minMaxRetailPrice', label: this.$t('results.tableHeaders.minMaxRc') as string},
        {key: 'productRange', label: this.$t('results.tableHeaders.line') as string},
        {key: 'lastPrice', label: this.$t('shared.labels.lastPrice') as string},
        {key: 'priceSegment', label: this.$t('results.tableHeaders.priceSegment') as string},
        {key: 'actualProfitability', label: this.$t('shared.labels.actualProfitability') as string},
        {key: 'purchasePriceAvgM', label: this.$t('results.tableHeaders.avgPurchasePrice') as string},
        {key: 'purchasePrice', label: this.$t('results.tableHeaders.promoPurchasePrice') as string},
        {key: 'coefficentList', label: this.$t('results.tableHeaders.priceOptStrategy') as string},
        {key: 'marginalProfit', label: this.$t('results.tableHeaders.minMarginSku') as string},
        {key: 'maxMarginalProfit', label: this.$t('results.tableHeaders.maxMarginSku') as string},
        {key: 'kviStrategy', label: this.$t('results.tableHeaders.kviStrategy') as string},
        {key: 'percentageOfCompetitorsPrice', label: this.$t('results.tableHeaders.correction') as string},
        {key: 'newProductPriceStrategy', label: this.$t('results.tableHeaders.newProductPriceStrategy') as string},
        {key: 'priceGap', label: this.$t('results.tableHeaders.priceGap') as string},
    ];

    newNewProductsTableFields: any[] = [
        {dataIndex: 'internalCode', title: this.$t('results.tableHeaders.internalCode') as string, width: 120},
        {dataIndex: 'productSegmentName', title: this.$t('results.tableHeaders.productSegment') as string, width: 130, scopedSlots: { filterDropdown: 'productSegmentNameFilter', filterIcon: 'productSegmentNameFilterIcon'}, ellipsis: true},
        {dataIndex: 'skuName', scopedSlots: { title: 'sku' }, width: 110, ellipsis: true},
        {dataIndex: 'keyCharacteristicOfTheProductIsOne', title: this.$t('results.tableHeaders.kht1') as string, width: 150, scopedSlots: { filterDropdown: 'kxt1Filter', filterIcon: 'kxt1FilterIcon' }, ellipsis: true},
        {dataIndex: 'keyCharacteristicOfTheProductIsTwo', title: this.$t('results.tableHeaders.kht2') as string, width: 150, scopedSlots: { filterDropdown: 'kxt2Filter', filterIcon: 'kxt2FilterIcon' }, ellipsis: true},
        {dataIndex: 'recipeAttribute', title: this.$t('results.tableHeaders.prc') as string, width: 150, scopedSlots: { filterDropdown: 'prcFilter', filterIcon: 'prcFilterIcon' }, ellipsis: true},
        {dataIndex: 'treatmentAttribute', title: this.$t('results.tableHeaders.pkl') as string, width: 150, scopedSlots: { filterDropdown: 'pklFilter', filterIcon: 'pklFilterIcon' }, ellipsis: true},
        {dataIndex: 'promoType', title: this.$t('results.tableHeaders.promoType') as string, scopedSlots: { customRender: 'promoType' }, width: 100},
        {dataIndex: 'lift', title: this.$t('shared.parametersTab.regularPriceCorrection') as string, scopedSlots: { customRender: 'lift' }, width: 130},
        {dataIndex: 'kvi', title: 'KVI', scopedSlots: { customRender: 'kvi', filterDropdown: 'kviFilter', filterIcon: 'kviFilterIcon' }, width: 80},
        {dataIndex: 'ctm', title: 'CTM', width: 80, scopedSlots: { filterDropdown: 'ctmFilter', filterIcon: 'ctmFilterIcon' }, ellipsis: true},
        {dataIndex: 'minMaxRetailPrice', title: this.$t('results.tableHeaders.minMaxRc') as string, scopedSlots: { customRender: 'minMaxRetailPrice' }, width: 100},
        {dataIndex: 'productRange', title: this.$t('results.tableHeaders.line') as string, width: 100},
        {dataIndex: 'lastPrice', scopedSlots: { customRender: 'lastPrice', title: 'lastPriceTitle' }, width: 100},
        {dataIndex: 'priceSegment', title: this.$t('results.tableHeaders.priceSegment') as string, scopedSlots: { customRender: 'priceSegment', filterDropdown: 'priceSegmentFilter', filterIcon: 'priceSegmentFilterIcon' }, width: 110},
        {dataIndex: 'actualProfitability', scopedSlots: { customRender: 'actualProfitability', title: 'actualProfitabilityTitle' }, width: 120},
        {dataIndex: 'purchasePriceAvgM', title: this.$t('results.tableHeaders.avgPurchasePrice') as string, scopedSlots: { customRender: 'purchasePriceAvgM' }, width: 100},
        {dataIndex: 'purchasePrice', label: this.$t('results.tableHeaders.promoPurchasePrice') as string, scopedSlots: { customRender: 'purchasePrice' }, width: 150},
        {dataIndex: 'coefficentList', title: this.$t('results.tableHeaders.priceOptStrategy') as string, scopedSlots: { customRender: 'coefficentList' }, width: 130},
        {dataIndex: 'marginalProfit', title: this.$t('results.tableHeaders.minMarginSku') as string, scopedSlots: { customRender: 'marginalProfit' }, width: 150},
        {dataIndex: 'maxMarginalProfit', title: this.$t('results.tableHeaders.maxMarginSku') as string, scopedSlots: { customRender: 'maxMarginalProfit' }, width: 150},
        {dataIndex: 'kviStrategy', title: this.$t('results.tableHeaders.kviStrategy') as string, scopedSlots: { customRender: 'kviStrategy' }, width: 110},
        {dataIndex: 'percentageOfCompetitorsPrice', title: this.$t('results.tableHeaders.correction') as string, scopedSlots: { customRender: 'percentageOfCompetitorsPrice' }, width: 150},
        {dataIndex: 'newProductPriceStrategy', title: this.$t('results.tableHeaders.newProductPriceStrategy') as string, scopedSlots: { customRender: 'newProductPriceStrategy' }, width: 160, ellipsis: true},
        {dataIndex: 'priceGap', title: this.$t('results.tableHeaders.priceGap') as string, scopedSlots: { customRender: 'priceGap' }, width: 100},
        {
          dataIndex: 'productVolume',
          title: this.$t('results.tableHeaders.productVolume') as string,
          customRender: (value: any) => this.numberFormatter(value),
          ellipsis: false,
          width: 40,
        },
        {
          dataIndex: 'measurementUnit',
          title: this.$t('results.tableHeaders.measurementUnit') as string,
          ellipsis: false,
          width: 30,
        },
        {
          dataIndex: 'productVerticalLine',
          title: this.$t('results.tableHeaders.productVerticalLine') as string,
          ellipsis: true,
          width: 70,
        },
        {
          dataIndex: 'isVerticalLineBase',
          title: this.$t('results.tableHeaders.isVerticalLineBase') as string,
          customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
          ellipsis: false,
          width: 50,
        },
        {
          dataIndex: 'vlStrategyStr',
          title: this.$t('results.tableHeaders.vlStrategyStr') as string,
          ellipsis: false,
          width: 70,
        },
        {
          dataIndex: 'vlGapPc',
          title: this.$t('results.tableHeaders.vlGapPc') as string,
          customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
          ellipsis: false,
          width: 70,
        },
    ];
    rulesTableFields: TableHeaders[] = [
        {key: 'fileDownload', label: this.$t('shared.labels.actions') as string},
        {key: 'errors', label: this.$t('shared.labels.errors') as string},
        {key: 'uploadDate', label: this.$t('shared.labels.modifiedDate') as string},
        {key: 'user', label: this.$t('shared.labels.user') as string},
        {key: 'storeFormat', label: this.$t('shared.filters.storeFormatChannel') as string},
        {key: 'storeRegions', label: this.$t('shared.filters.storeRegion') as string},
        {key: 'storeCluster', label: this.$t('shared.filters.storeCluster') as string},
        {key: 'groupsOfProduct', label: this.$t('results.tableHeaders.productGroup') as string},
        {key: 'categories', label: this.$t('results.tableHeaders.productCategory') as string},
        {key: 'subcategories', label: this.$t('shared.parametersTab.subcategory') as string},
    ];

    newRulesTableFields: any[] = [
        {
            dataIndex: 'fileDownload',
            title: this.$t('shared.labels.actions') as string,
            scopedSlots: { customRender: 'fileDownload' },
        },
        {
            dataIndex: 'errors',
            title: this.$t('shared.labels.errors') as string,
            scopedSlots: { customRender: 'errors' }},
        {
            dataIndex: 'uploadDate',
            title: this.$t('shared.labels.modifiedDate') as string,
            customRender: (value: number) => moment(moment.utc(value)).local().format('DD/MM/YYYY HH:mm:ss'),
            scopedSlots: { filterDropdown: 'uploadDateFilter', filterIcon: "uploadDateFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'user',
            title: this.$t('shared.labels.user') as string,
            scopedSlots: { filterDropdown: 'userFilter', filterIcon: "userFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeFormat',
            title: this.$t('shared.filters.storeFormatChannel') as string,
            scopedSlots: { filterDropdown: 'storeFormatFilter', filterIcon: "storeFormatFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeRegions',
            title: this.$t('shared.filters.storeRegion') as string,
            scopedSlots: { filterDropdown: 'storeRegionsFilter', filterIcon: "storeRegionsFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeCluster',
            title: this.$t('shared.filters.storeCluster') as string,
            scopedSlots: {filterDropdown: 'storeClusterFilter', filterIcon: "storeClusterFilterIcon"},
            ellipsis: true,
        },
        {
            dataIndex: 'groupsOfProduct',
            title: this.$t('results.tableHeaders.productGroup') as string,
            scopedSlots: { filterDropdown: 'groupsOfProductFilter', filterIcon: "groupsOfProductFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'categories',
            title: this.$t('results.tableHeaders.productCategory') as string,
            scopedSlots: { filterDropdown: 'categoriesFilter', filterIcon: "categoriesFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'subcategories',
            title: this.$t('shared.parametersTab.subcategory') as string,
            scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" },
            ellipsis: true,
        },
    ];

    tableData: any = [];
    pagination: any = {
        pageSize: 20,
    };

    loadingConfigs = false;
    marginalErrorText = ''
    maxMarginalErrorText = ''
    marginalSkuErrorText = ''
    competitorsMaximumProfitPromoErrorText = ''
    incorrectPeriodErrorText = '';
    globalNewProductIndividualMarginalErrorText = '';
    globalIndividualMarginalErrorText = '';
    globalNewProductIndividualMarginalBlockButton = false;
    globalLiftBlockButton = false;
    globalNewProductLiftBlockButton = false;
    globalIndividualMarginalBlockButton = false;
    globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
    globalIndividualPriceIncreaseLimitBlockButton = false;

    downloadLastExcelHeaderByFilters: boolean = false;
    downloadLastExcelDetailByFilters = false;
    skuListPerPage = 20;
    newProductListPerPage: number = 20;
    skuListCurrentPage: number = 1;
    skuRecommendsListCurrentPage: number = 1;
    newProductsListCurrentPage: number = 1;
    skuListTotalRows: number = 0;
    newProductsListTotalRows: number = 0;
// tslint:disable-next-line: ban-types
    onDropdownClosed: Function | null = null;
    needLoadSkuList: boolean = false;
    showBookmarks: boolean = true;
    showPromoRecommendsBookmarks: boolean = true;
    showMainFilters: boolean = true;
    showMainRecommendsFilters: boolean = true;
    needLoadNewProductList: boolean = false;
    firstDate: number = 0;
    lastDate: number = 0;
    calcModalShow: boolean = false;
    recalculatingRegularPricesModalShow: boolean = false;
    isActualProfitabilityCalculated: boolean = false;
    isRegularPricesProfitabilityCalculated: boolean = false;
    isDataRangeCalculated: boolean = false;
    isPriceCorridorCalculated: boolean = false;
    isFetchSkuListDownload: boolean = false;
    isFetchNewProductsListDownload: boolean = false;
    isLoadCompetitorPrices: boolean = false;
    kviSaveProcess: boolean = false;
    calcSkuActualProfitButtonDisabled: boolean = false;
    newProductsLastPage: number = 0;
    calcSkuLastPricesButtonDisabled: boolean = false;
    useFindKviRecommendsParam: boolean = false;
    tabs: BTabs | null = null;
    isFiltersChangedForRecommends = 1;
    loadProgress: boolean = false;
    progressCounter: number = 0;
    rulesCurrentPage = 1;
    rulesTotalRows = 0;
    rulesPerPage = 20;
    rulesTableKey = 1;
    rulesDateRange: string[] = [];
    showDeleteFileModal: boolean = false;
    fileIdForDelete: number = -1;
    serverConfigTimeout: number | null = null;
    currentMainTab: string = "mainParameters"

    selectUserFio: string = 'All';
    usersFioList: Array<SelectBox<string>> = [];

    selectTradingFilter: SelectBox<number> = this.defaultFilterValue;
    tradingsFilterOptions: Array<SelectBox<number>> = [];

    selectCategoryFilter: number = this.defaultFilterValue.value;
    categoryFilterOptions: Array<SelectBox<number>> = [];

    selectGroupFilter: number = this.defaultFilterValue.value;
    groupFilterOptions: Array<SelectBox<number>> = [];

    selectSubcategoryFilter: number = this.defaultFilterValue.value;
    subcategoryFilterOptions: Array<SelectBox<number>> = [];

    selectFormatFilter: number = this.defaultFilterValue.value;
    formatFilterOptions: Array<SelectBox<number>> = [];

    selectRegionFilter: number = this.defaultFilterValue.value;
    regionFilterOptions: Array<SelectBox<number>> = [];

    selectClusterFilter: number = this.defaultFilterValue.value;
    clusterFilterOptions: Array<SelectBox<number>> = [];

    isFixPricePromo: boolean = false;

    private globalIndividualPromoType: SelectBox<PromoType> | null = null;
    private globalIndividualLift: number | null = null;
    private globalIndividualPromoPurchasePrice: number | null = null;
    private globalIndividualPriceStrategy: SelectBox<Coefficents> | null = null;
    private globalIndividualPriceIncreaseLimit: number | null = null;
    private globalIndividualPeriodPriceIncreaseLimit: number | null = null;
    private globalIndividualPeriod: SelectBox<number> | null = null;
    private globalIndividualMarginalProfitability: number | null = null;
    private globalIndividualKviStrategy: SelectBox<KviStrategies> | null = null;

    private globalIndividualPercentageOfCompetitorsPrice: string | null = null;
    private globalIndividualNewProductPromoType: SelectBox<PromoType> | null = null;
    private globalIndividualNewProductLift: number | null = null;
    private globalIndividualNewProductPromoPurchasePrice: number | null = null;
    private globalIndividualNewProductStrategyOpt: SelectBox<Coefficents> | null = null;
    private globalIndividualNewProductMarginalProfitability: number | null = null;
    private globalIndividualNewProductKviStrategy: SelectBox<KviStrategies> | null = null;
    private globalIndividualNewProductPercentageOfCompetitorsPrice: string | null = null;
    private globalIndividualNewProductPriceStrategy: SelectBox<NewProductPriceStrategy> | null = null;

    private globalIndividualNewProductPriceGap: number | null = null;
    private refreshSkuListId = -1;
    private refreshNewProductsListId = -1;
    private refreshAllRecommendsId = -1;
    private refreshPiRecommendsId = -1;
    private refreshCdRecommendsId = -1;
    private refreshIgRecommendsId = -1;
    private dropDownOpen = false;
    private dropDownOpenForRoundingRules = false;
    // tslint:disable-next-line: ban-types
    private onDropdownClosedForRoundingRules: Function | null = null;
    private showSku: boolean = false;
    private showSkuAndSearch: boolean = true;
    private skuListWithCalculating: boolean = false;
    private newProductsWithCalculating: boolean = true;
    private skuRecommendsCalculate: boolean = false;
    private httpExecutor: HttpExecutor = new HttpExecutor();
    private showDataRange: boolean = false;
    private sortBySKU: number = -1;
    private sortingNewProductsBySKU: number = -1;
    private sortBySKUForPiRecommends: number = -1;
    private sortBySKUForCdRecommends: number = -1;
    private sortBySKUForIgRecommends: number = -1;
    private sortBySKUValueForRecommends: number = -1;
    private actualProfitability: number | null = null;
    private regularPricesProfitability: number | null = null;
    private isFiltersChanged = 1;
    private lastPage = 0;
    private findAutomaticallyPriceSegments = false;
    private countPriceSegments = 1;
    private productCodesForAddKvi: string[] = []
    private productCodesForDeleteKvi: string[] = []
    private productCodesForAddCtmPurpose: string[] = []
    private productCodesForDeleteCtmPurpose: string[] = []
    private needCalculateSkuLastPricesOnly: boolean = false;

    private needCalculateSkuActualProfitabilityOnly: boolean = false;
    private promoInternalCodesFromPromoFile: string[] = []

    private promoDisabledInternalCodes: string[] = []

    private viz: any | null = null;
    private rulesLimit: number = 20;
    private refreshRulesListId = -1;
    private needLoadFiltersForTable: boolean = true;

    private api: ModuleApi = new ModuleApi({parent: this});

    private saveItem(params: IModuleItemSaveDto): Promise<any> {
        return new Promise<IModuleItem>((resolve, reject) => {
            this.api.saveItem(this.moduleType, params)
                .then((res) => {
                    resolve(res as any);
                })
                .catch((err) => {
                    reject(err);
                    this.showError(this.$t('shared.parametersTab.errorSaveItem', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameAcc') as string : this.$t('sales.typeNameAcc') as string }) as string);
                });
        })
    }

    async updateBasicItemParams() {
        let itemToSave: IModuleItem | IModuleItemSaveDto = Object.assign({}, this.itemToEdit);

        if (this.moduleData.selectMarket.id != null) {
            Object.assign(itemToSave, {
                id: this.itemToEdit.id,
                tradingId: this.itemToEdit.tradingId,
                groupIds: this.entityFilters.groupIds.realValuesOrEmpty(),
                categoryIds: this.entityFilters.categoryIds.realValuesOrEmpty(),
                subcategoryId: this.entityFilters.subcategoryId ? this.entityFilters.subcategoryId : null,
                formatId: this.entityFilters.formatId ? this.entityFilters.formatId : null,
                regionIds: this.entityFilters.regionIds.realValuesOrEmpty(),
                clusterIds: this.entityFilters.clusterIds.realValuesOrEmpty(),
            });
        }

        await this.saveItem(itemToSave)
            .then((res) => {
                this.$emit('basic-item-params-updated', {
                    success: true,
                    data: res.data,
                });
            })
            .catch((err) => {
                this.$emit('basic-item-params-updated', {
                    success: false,
                    err,
                });
            });
    }

    getRulesFilters(): BaseFilterRoundingRules {
        return {
            filterType: 'PROMO',
            tradingId: this.$roundingRules.selectMarket.id,
            category: this.$roundingRules.categoryOfProduct,
            groupOfProduct: this.$roundingRules.groupOfProduct,
            seasonValues: this.$roundingRules.seasonSelected,
            buyerSegments: this.$roundingRules.buyerSegmentsList,
            storeRegionValues: this.$roundingRules.regionSelected,
            categoryStrategy: this.$roundingRules.categoryStrategy.value,
            storeFormat: this.$roundingRules.formatSelected,
            subcategories: this.$roundingRules.subcategories,
            productSegments: this.$roundingRules.productSegments,
            allNewPricesWithoutPennies: this.$roundingRules.allNewPricesWithoutPennies,
            storeCluster: this.$roundingRules.clusterSelected,
            pennies: this.$roundingRules.pennies,
            randomPennies: this.$roundingRules.randomPennies,
            roundKviCompetitorPrice: this.$roundingRules.roundKviCompetitorPrice,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            bigDigit: this.$roundingRules.bigDigit,
            manualPennies: this.$roundingRules.manualPennies,
        }
    }

    numberFormatter = (v: any): string => FormatNumber.format(v);

    searchPackagePromoRecommends() {
        const filters = this.getPackagePromoRecommendsFilter();
        this.savePackagePromoRecommends();
        this.httpAddPackagePromoRecommendsTask(filters)
                .then((r) => {
                  this.showInfo(this.$t('shared.parametersTab.calcStarted') as string);
                  this.$log.debug('Create task', r.data);
                })
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorStartCalc') as string);
                });
    }

    mounted() {
        this.setParamsVerticalTabsHeight();

        this.tabs = this.$refs.mainTabs as BTabs;

        this.moduleData.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('shared.parametersTab.maxGrossMargin') as string}
    }

    beforeDestroy() {
        this.$calc.hintsLoaded = false
        this.$calc.currentModuleHints = [];
    }

    destroyed() {
        if (this.viz != null) {
            this.viz.dispose();
        }
    }

    created() {
        this.httpLoadModuleHints('Promo').then((r) => {
            this.$calc.currentModuleHints = r.data
            this.$calc.hintsLoaded = true
        }).catch((e) => {
        });
    }

    dataRangeInfo() {
        if (!this.showDataRange) {
            return;
        }
        if (this.moduleData.selectMarket.id === -1 || !this.moduleData.categoryIds.length) {
            this.firstDate = 0;
            this.lastDate = 0;
            return;
        }
        this.isDataRangeCalculated = true;

        const filters = this.getItemsFilter();
        this.httpExecutor.executeHttp(this.httpPostDataRange, filters)
                .then((d) => {
                            if (!d.ignore) {
                                const r = d.response;
                                if (r.data.firstDate == null && r.data.lastDate == null) {
                                    this.firstDate = 0;
                                    this.lastDate = 0;
                                    this.showInfo(this.$t('shared.parametersTab.noDateRangeData') as string);
                                    this.isDataRangeCalculated = false;
                                } else {
                                    this.firstDate = r.data.firstDate;
                                    this.lastDate = r.data.lastDate;
                                    this.isDataRangeCalculated = false;
                                }
                            }
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorGetDateRange') as string);
                    this.$log.error('Error occurred [load data range]', e);
                    this.isDataRangeCalculated = false;
                });
    }

    resetTables() {
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
    }

    resetActualProfitability() {
        this.actualProfitability = null;
    }

    resetRegularPricesProfitability() {
        this.regularPricesProfitability = null;
    }

    resetCompetitors() {
        this.competitors = [];
        this.moduleData.competitorsCodes = [];
    }

    hideNewProductPricingPanel(): boolean {
        return this.$disallowedModules.includes('newProduct-pricing');
    }

    tryFindParams() {
        // const [selectSeasons, selectRegions] = this.selectData();

        // temporary - must request from server (need route)
        this.itemToEdit = Object.assign({}, this.currentItem);

        const findParams = new FindFiltersParams();

        findParams.tradingId = this.itemToEdit.tradingId;
        findParams.groupOfProduct = null;
        findParams.category = null;
// tslint:disable-next-line: no-non-null-assertion
        findParams.subcategories = [];
// tslint:disable-next-line: no-non-null-assertion
        findParams.productSegments = [];
        findParams.storeCluster = null;
        findParams.seasonValues = [];
        findParams.storeRegionValues = [];
        findParams.storeFormat = null;
        findParams.categoryStrategy =  this.$roundingRules.categoryStrategy.value;

        if (this.moduleType === 'promo') {
            findParams.promotionId = this.itemToEdit.id;
        } else {
            findParams.saleId = this.itemToEdit.id;
        }

        if (this.moduleType === 'promo' ? findParams.canLoadPromotionParams() : findParams.canLoadSaleParams()) {
            this.loadingConfigs = true;

            this.loadCommonParams(findParams)
                    .catch((e) => {
                        this.loadingConfigs = false;
                        this.$log.error('Error occurred while loading configs', e);
                        this.showError(this.$t('shared.parametersTab.errorLoadItemParams', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string }) as string);
                    })
                    .finally(() => {
                        this.saveModuleItems();
                        this.loadingConfigs = false
                    });
        }
    }

    selectInternalCodesRecomendations(): string[] {
        let result: string[] = [];
        if (this.usePromoRecommendsFilter) {
            const recommendsType = this.selectedPromoFilter;
            if (recommendsType === PromoFilterType.cd) {
                result = this.cartDrivers.map((i) => i.internalCode);
            } else if (recommendsType === PromoFilterType.ig) {
                result = this.incomeGenerators.map((i) => i.internalCode);
            } else if (recommendsType === PromoFilterType.pi) {
                result = this.trafficGenerators.map((i) => i.internalCode);
            }
        }
        return result;
    }

    recommendsListByType(): string[] {
        let result: string[] = [];
        if (this.recommendsType === PromoFilterType.cd) {
            result = this.cartDrivers.map((i) => i.internalCode);
        } else if (this.recommendsType === PromoFilterType.ig) {
            result = this.incomeGenerators.map((i) => i.internalCode);
        } else if (this.recommendsType === PromoFilterType.pi) {
            result = this.trafficGenerators.map((i) => i.internalCode);
        }
        return result;
    }

    selectData(): [number[], number[], number[], string[], string | null, Segment[] | null, string[] | null] {
        const selectSeasons: number[] = (this.moduleData.seasonSelected.length === 0 || (this.moduleData.seasonSelected.length === 1 && this.moduleData.seasonSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.moduleData.seasonSelected)!!;
        const selectRegions: number[] = (!this.moduleData.regionIds.length || (this.moduleData.regionIds.length === 1 && this.moduleData.regionIds[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.moduleData.regionIds)!!;

        const selectBuyerSegment: number[] = (this.moduleData.buyerSegmentsList.length === 0 || (this.moduleData.buyerSegmentsList.length === 1 && this.moduleData.buyerSegmentsList[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.moduleData.buyerSegmentsList)!!;
        const selectedSku: string[] = (this.moduleData.selectedSkuList.length === 0 || this.moduleData.selectedSkuList.length === 1 && this.moduleData.selectedSkuList[0].value === null)
                ? []
                : (this.moduleData.selectedSkuList).filter((item) => item.value !== null).map((item) => {
                    return (item.value);
                });
        const ctm: string | null = this.selectCTM === 'all' ? null : this.selectCTM;
        this.selectSegmentPrice = this.selectSegmentPrice.filter((item) => {
            return item.name !== 'All'
        });
        const priceSegments: Segment[] | null = this.selectSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        const recommendsCodes: string[] = this.selectInternalCodesRecomendations();
        return [selectSeasons, selectRegions, selectBuyerSegment, selectedSku, ctm, priceSegments, recommendsCodes];
    }

    selectDataForRoundingRulesSeasonsRegions(): [number[], number[], number[]] {
        const selectSeasons: number[] = (this.$roundingRules.seasonSelected.length === 0 || (this.$roundingRules.seasonSelected.length === 1 && this.$roundingRules.seasonSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$roundingRules.seasonSelected)!!;
        const selectRegions: number[] = (this.$roundingRules.regionSelected.length === 0 || (this.$roundingRules.regionSelected.length && this.$roundingRules.regionSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$roundingRules.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$roundingRules.buyerSegmentsList.length === 0 || (this.$roundingRules.buyerSegmentsList.length === 1 && this.$roundingRules.buyerSegmentsList[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$roundingRules.buyerSegmentsList)!!;
        // const ctm: string | null = this.selectCTM.value === 'all' ? null : this.selectCTM.value;

        this.$log.log(selectRegions)
        return [selectSeasons, selectRegions, selectBuyerSegment];
    }

    selectDataRecommends(): [number[], number[], number[], number[]] {
        const selectSeasons: number[] = (this.$packagePromoRecommends.seasonSelected.length === 0 || (this.$packagePromoRecommends.seasonSelected.length === 1 && this.$packagePromoRecommends.seasonSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packagePromoRecommends.seasonSelected)!!;
        const selectRegions: number[] = (this.$packagePromoRecommends.regionSelected.length === 0 || (this.$packagePromoRecommends.regionSelected.length && this.$packagePromoRecommends.regionSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packagePromoRecommends.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$packagePromoRecommends.buyerSegmentsList.length === 0 || (this.$packagePromoRecommends.buyerSegmentsList.length && this.$packagePromoRecommends.buyerSegmentsList[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packagePromoRecommends.buyerSegmentsList)!!;
        const selectFormats: number[] = (this.$packagePromoRecommends.formatSelected.length === 0 || (this.$packagePromoRecommends.formatSelected.length && this.$packagePromoRecommends.formatSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packagePromoRecommends.formatSelected)!!;
        return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
    }

    getSegmentPriceInfo() {
        if (this.moduleData.selectMarket.id === -1 || !this.moduleData.categoryIds.length) {
            return;
        }
        const filter = this.getSkuFilter()
        this.httpGetMinMaxPriceSegment(filter)
                .then((data) => {
                    const filterData = data.data;
                    this.segmentPriceOptions = filterData.map((i) => {
                        return {value: i, label: i.name}
                    });
                })
                .catch((e) => {
                })
    }

    prepareIndividualConfig(config: SaleIndividualConfig | PromotionIndividualConfig): SaleServerIndividualConfig | PromotionsServerIndividualConfig {
        const prepared: SaleServerIndividualConfig | PromotionsServerIndividualConfig = {};

        if ('minPrice' in config && typeof config.minPrice !== 'undefined' && config.minPrice != null) {
            prepared.minPrice = config.minPrice;
        }

        if ('maxPrice' in config && typeof config.maxPrice !== 'undefined' && config.maxPrice != null) {
            prepared.maxPrice = config.maxPrice;
        }

        if ('minProfitability' in config && typeof config.minProfitability !== 'undefined' && config.minProfitability != null) {
            prepared.minProfitability = config.minProfitability;
        }

        if ('minDiscount' in config && typeof config.minDiscount !== 'undefined' && config.minDiscount != null) {
            prepared.minDiscount = config.minDiscount;
        }

        if ('maxDiscount' in config && typeof config.maxDiscount !== 'undefined' && config.maxDiscount != null) {
            prepared.maxDiscount = config.maxDiscount;
        }

        if ('remains' in config && typeof config.remains !== 'undefined' && config.remains != null) {
            prepared.remains = config.remains;
        }

        return prepared;
    }

    prepareCommonIndividualConfig(config: IndividualConfig): CalcIndividualConfig {
        const prepared: CalcIndividualConfig = {};

        if ('kviStrategy' in config && typeof config.kviStrategy !== 'undefined' && config.kviStrategy !== null) {
            prepared.kviStrategy = config.kviStrategy.value
        }

        if ('marginalProfit' in config && typeof config.marginalProfit !== 'undefined' && config.marginalProfit != null) {
            prepared.marginalProfit = config.marginalProfit;
        }

        if ('selectCoefficent' in config && typeof config.selectCoefficent !== 'undefined' && config.selectCoefficent !== null) {
            const coef = config.selectCoefficent;
            prepared.coefficientK1 = coef.value.k1;
            prepared.coefficientK2 = coef.value.k2;
            prepared.priceOpt = coef.value.enum;
        }

        if ('priceIncreaseLimit' in config && typeof config.priceIncreaseLimit !== 'undefined' && config.priceIncreaseLimit != null) {
            prepared.priceIncreaseLimit = config.priceIncreaseLimit;
        }

        if ('competitorsPricesParams' in config && typeof config.competitorsPricesParams !== 'undefined' && config.competitorsPricesParams != null) {
            prepared.competitorsPricesParams = config.competitorsPricesParams;
        }

        if ('percentageOfCompetitorsPrice' in config) {
            prepared.percentageOfCompetitorsPrice = config.percentageOfCompetitorsPrice;
        }

        if ('periodPriceIncreaseLimit' in config && typeof config.periodPriceIncreaseLimit !== 'undefined' && config.periodPriceIncreaseLimit != null) {
            prepared.periodPriceIncreaseLimit = config.periodPriceIncreaseLimit;
        }

        if ('period' in config && typeof config.period !== 'undefined' && config.period !== null) {
            prepared.period = config.period.value;
        }

        if ('newProductPriceStrategy' in config && typeof config.newProductPriceStrategy !== 'undefined' && config.newProductPriceStrategy !== null) {
            prepared.newProductPriceStrategy = config.newProductPriceStrategy.value;
        }

        if ('priceGap' in config && typeof config.priceGap !== 'undefined' && config.priceGap != null) {
            prepared.priceGap = config.priceGap;
        }

        return prepared;
    }

    getItemsFilter(): ModuleItemFilters {
        const [selectSeasons, selectRegions, selectBuyerSegment, selectedSku] = this.selectData();
        const allCheck = this.moduleData.allCheck;
        // const pennies = this.moduleData.pennies;
        const countAtLastPurchasePrice = this.moduleData.countAtLastPurchasePrice;
        const countAtFuturePurchasePrice = this.moduleData.countAtFuturePurchasePrice;
        // const allNewPricesWithoutPennies = this.moduleData.allNewPricesWithoutPennies;
        const allClaster = this.moduleData.allClaster;
        const individualConfigsObj = Object.create(null);
        const individualCommonConfObj = Object.create(null);
// tslint:disable-next-line: forin
        for (const key in this.moduleData.individualConfig) {
            const value = this.moduleData.individualConfig[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = this.prepareIndividualConfig(value);
            }
        }

// tslint:disable-next-line: forin
        for (const key in this.moduleData.individualCommonParams) {
            const value = this.moduleData.individualCommonParams[key];
            if (typeof value !== 'undefined' && value != null) {
                individualCommonConfObj[key] = this.prepareCommonIndividualConfig(value);
            }
        }

        return {
            xyzChecked: this.moduleData.xyzChecked,
            uvwChecked: this.moduleData.uvwChecked,
            discountPrise: this.moduleData.discountPrice,
            allCheck,
            // pennies,
            countAtLastPurchasePrice,
            countAtFuturePurchasePrice,
            // allNewPricesWithoutPennies,
            allClaster,
            coefficientK1: this.moduleData.selectCoefficent.value.k1,
            coefficientK2: this.moduleData.selectCoefficent.value.k2,
            category: null,
            storeCluster: null,
            storeClusters: this.itemToEdit.clusters.map(el => el.id).realValuesOrEmpty(),
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            spreadUVWParams: this.moduleData.uvwParams,
            spreadXYZParams: this.moduleData.xyzParams,
            storeRegionValues: this.itemToEdit.regions.map(el => el.id).realValuesOrEmpty(),
            groupsOfProduct: this.itemToEdit.groups.map(el => el.id).realValuesOrEmpty(),
            categories: this.itemToEdit.categories.map(el => el.id).realValuesOrEmpty(),
            storeFormat: this.itemToEdit.format.id,
            tradingId: this.itemToEdit.tradingId!,
            calculationDepth: +this.moduleData.calculationDepth,
            correlation: this.moduleData.correlation ? this.moduleData.correlation : 0.7,
            highElasticity: this.moduleData.highElasticity ? this.moduleData.highElasticity : -0.5,
            intervalOfUltimateElasticity: this.moduleData.intervalOfUltimateElasticity,
            competitorsPricesParams: this.moduleData.competitorsPrices,
            kviStrategy: this.moduleData.kviStrategy.value,
            percentageOfCompetitorsPrice: this.moduleData.percentageOfCompetitorsPrice,
            marginalProfitability: this.moduleData.marginalProfitability,
            marginalProfit: this.moduleData.marginalProfit,
            maxMarginalProfit: this.moduleData.maxMarginalProfit != null ? this.moduleData.maxMarginalProfit : 100,
            marginalPriceDifference: this.moduleData.marginalPriceDifference,
            calculationDay: this.periodForCalculatingEntered ? this.periodForCalculatingEntered as number : +this.moduleData.calculationDay,
            priceCorridor: this.moduleData.priceCorridor,
            changePriceCorridor: this.moduleData.changePriceCorridor,
            priceIncreaseLimit: this.moduleData.priceIncreaseLimit,
            fixLowerBorder: this.moduleData.fixLowerBorder,
            individualCommonParams: individualCommonConfObj,
            depthToPurchasePrice: this.moduleData.depthToPurchasePrice,
            priceFamilies: this.moduleData.priceFamilies,
            hardPriceFamilies: this.moduleData.hardPriceFamilies,
            // groupOfProduct: this.moduleData.groupOfProduct,
            groupOfProduct: null,
// tslint:disable-next-line: no-non-null-assertion
            priceOpt: this.moduleData.selectCoefficent.value.enum!,
// tslint:disable-next-line: no-non-null-assertion
            subcategories: !this.itemToEdit.subcategory || this.itemToEdit.subcategory.id == null || this.itemToEdit.subcategory.id <= 0 ? null : [this.itemToEdit.subcategory.id],
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.moduleData.productSegments)!!,
            useCompetitorsPrices: this.moduleData.useCompetitorsPrices,
            byPromoPrices: this.moduleData.byPromoPrices,
            competitorsPricePeriod: this.moduleData.competitorsPricePeriod,
            competitorsCodes: this.moduleData.competitorsCodes,
            competitorsPriceMethod: this.moduleData.competitorsPriceMethod.value,
            competitorsPriceAdjustment: this.moduleData.competitorsPriceAdjustment,
            competitorsInfluencesCoef: this.moduleData.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.moduleData.competitorsMinimumProfit,
            competitorsMaximumProfit: this.moduleData.competitorsMaximumProfit != null ? this.moduleData.competitorsMaximumProfit : 100,
            competitorsControlParam: this.moduleData.competitorsControlParam,
            competitorsPriceStrategy: this.moduleData.competitorsPriceStrategy.value,
            // roundKviCompetitorPrice: this.moduleData.roundKviCompetitorPrice,
            calculateByRegression: !this.moduleData.calculateByElasticity,
            recalculateCtm: this.moduleData.recalculateCtm,
            individualPromoConfigs: individualConfigsObj,
            availableStockDelta: this.moduleData.availableStockDelta,
            promoInternalCodes: selectedSku,
            ...(this.moduleType === 'promo' ? { promoType: this.itemToEdit.type! as PromoType } : {}),
            lift: this.moduleData.lift,
            purchasePrice: this.moduleData.purchasePrice,
            crossCalculation: this.moduleData.crossCalculation,
            newProductLifespanInDays: this.moduleData.newProductLifespanInDays,
            calculateCommon: this.moduleData.calculateCommon,
            intervalOfCorrelationElasticity: this.moduleData.intervalOfCorrelationElasticity,
            priceChangeLimit: this.moduleData.priceChangeLimit,
            priceChangeLimitKvi: this.moduleData.priceChangeLimitKvi,
            priceChangeLimitComp: this.moduleData.priceChangeLimitComp,
            useBrutForcingParams: false,
            saveAfterOptimize: false,
            optimizationDiff: 0.0,
            calculatePYR: this.moduleData.calculatePYR,
            calculationType: this.moduleType === 'promo' ? this.calculationTypeValue : undefined,
            periodPriceIncreaseLimit: this.moduleData.periodPriceIncreaseLimit,
            period: this.moduleData.period.value,
            newProductPriceStrategy: this.moduleData.newProductPriceStrategy.value,
            priceGap: this.moduleData.priceGap,
            priceGapCtmPc: this.moduleData.priceGapCtmPc,
            findAutomaticallyPriceSegments: this.findAutomaticallyPriceSegments,
            countPriceSegments: this.countPriceSegments,
            considerPlannedSeason: this.moduleData.considerPlannedSeason,
            useDiscountDurationForForecastCalculation: this.moduleData.useDiscountDurationForForecastCalculation,
            useProductRange: this.moduleData.useProductRange,
            useSkuRotation: this.moduleData.useSkuRotation,
            promoCalc: true,
            percentageOfRecommendsKviCount: this.moduleData.percentageOfRecommendsKviCount,
            saveKviSign: this.moduleData.saveKviSign,
            useSegmentsPriceInSearchKVIRecParam: this.moduleData.useSegmentsPriceInSearchKVIRecParam,
            categoryStrategy: this.moduleData.categoryStrategy.value,
            useCompetitorsForKviRecommends: this.moduleData.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.moduleData.competitorsPeriodForKviRecommends,
            productCodesForAddKvi: this.productCodesForAddKvi,
            productCodesForDeleteKvi: this.productCodesForDeleteKvi,
            productCodesForAddCtmPurpose: this.productCodesForAddCtmPurpose,
            productCodesForDeleteCtmPurpose: this.productCodesForDeleteCtmPurpose,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            calculateCompAllowedDeviation: this.moduleData.calculateCompAllowedDeviation,
            minProfitKVI: this.moduleData.minProfitKVI,
            maxProfitKVI: this.moduleData.maxProfitKVI != null ? this.moduleData.maxProfitKVI : 100,
            productRangesAndInternalCodes: this.productRangesArray,
            // randomPennies: this.moduleData.randomPennies,
            excludeOutOfStock: this.moduleData.excludeOutOfStock,
            calculateBySalePoints: this.moduleData.calculateBySalePoints,
            ...(this.moduleType === 'sales' ? { calculateBySubcategories: (this.moduleData as Sales).calculateBySubcategories } : {}),
            trainModel: this.moduleData.trainModel,
            considerCannibalization: this.moduleType === 'promo' ? (this.moduleData as Promotions).considerCannibalization : false,
            useCompElasticity: this.moduleData.useCompElasticity,
            // manualPennies: this.moduleData.manualPennies,
            forecastAccuracy: this.moduleData.forecastAccuracy,
            percentileType: this.moduleData.percentileType.value,
            calcWithBatchNumber: false,
            competitorPriceControlParameterPc: this.moduleData.competitorPriceControlParameterPc,
            thompsonSampling: false,
            revaluationCalculateParams: this.getDefaultRevaluationCheckParams(),
            inflation: this.moduleData.inflation,
            calculateBySpeedSale: this.moduleData.calculateBySpeedSale,
            isFixPricePromo: this.moduleData.isFixPricePromo,
            spreadByPriceSegments: this.moduleData.spreadByPriceSegments,
            rotationPeriodType: this.moduleData.rotationPeriodType,
            promoQuote: this.moduleData.promoQuoteValue,
            promoPriceCalculationDepth: this.moduleData.promoPriceCalculationDepth,
            useCompetitorsPromoPrices: this.moduleData.useCompetitorsPromoPrices,
            calculateCompAllowedDeviationPromo: this.moduleData.calculateCompAllowedDeviationPromo,
            competitorPriceControlParameterPcPromo: this.moduleData.competitorPriceControlParameterPcPromo,
            competitorsPricePeriodPromo: this.moduleData.competitorsPricePeriodPromo,
            competitorsPromoPriceInfluencesCoef: this.moduleData.competitorsPromoPriceInfluencesCoef,
            percentileTypePromo: this.moduleData.percentileTypePromo,
            competitorsPromoPriceAdjustment: this.moduleData.competitorsPromoPriceAdjustment,
            competitorsControlPromoParam: this.moduleData.competitorsControlPromoParam,
            competitorsPromoPriceMethod: this.moduleData.competitorsPromoPriceMethod
                ? this.moduleData.competitorsPromoPriceMethod.value
                : this.competitorsPromoPriceMethodsOpts[0].value,
            competitorsMinimumProfitPromo: this.moduleData.competitorsMinimumProfitPromo,
            competitorsMaximumProfitPromo: this.moduleData.competitorsMaximumProfitPromo != null ? this.moduleData.competitorsMaximumProfitPromo : 100,
            competitorsPromoPriceStrategy: this.moduleData.competitorsPromoPriceStrategy
                ? this.moduleData.competitorsPromoPriceStrategy.value
                : this.competitorsPromoPriceStrategiesOpts[0].value,
            daysToPriceChangeStart: this.moduleData.daysToPriceChangeStart && this.moduleData.daysToPriceChangeStart > 0 
                ? this.moduleData.daysToPriceChangeStart 
                : null,
            daysToPriceChangeFinish: this.moduleData.daysToPriceChangeFinish && this.moduleData.daysToPriceChangeFinish > 0 
                ? this.moduleData.daysToPriceChangeFinish 
                : null,
            planningPromoPeriodStartDate:
                !!this.itemToEdit.startDate
                    ? moment.utc(this.itemToEdit.startDate).startOf('day').valueOf()
                    : null,
            planningPromoPeriodEndDate:
                !!this.itemToEdit.endDate
                    ? moment.utc(this.itemToEdit.endDate).startOf('day').valueOf()
                    : null,
            minDefaultDiscount: this.itemToEdit.minSaleDiscount || 0,
            maxDefaultDiscount: this.itemToEdit.maxSaleDiscount || 0,
            priceDecreaseLimit: this.moduleData.priceDecreaseLimit,
            minPromoPrice: this.moduleData.minPromoPrice,
        };
    }

    get priceDecreaseLimitValidate(): boolean {
        const priceDecreaseLimit = this.moduleData.priceDecreaseLimit;
        return priceDecreaseLimit != null && priceDecreaseLimit.toString() !== '' && priceDecreaseLimit >= 0;
    }

    getPackagePromoRecommendsFilter(): PackagePromoConfig {
        const [selectSeasons, selectRegions, selectBuyerSegment, selectFormats] = this.selectDataRecommends();
        const selectClusters: number[] = (this.$packagePromoRecommends.clusterSelected.length === 0 || (this.$packagePromoRecommends.clusterSelected.length && this.$packagePromoRecommends.clusterSelected[0] === 0))
                // tslint:disable-next-line: no-non-null-assertion
                ? [] : LocalData.filterNumberArrays(this.$packagePromoRecommends.clusterSelected)!!;
        return {
            tradingId: this.$packagePromoRecommends.selectMarket.id,
// tslint:disable-next-line: no-non-null-assertion
            categories: LocalData.filterNumberArrays(this.$packagePromoRecommends.categoriesOfProduct)!!,
            productSegments: LocalData.filterNumberArrays(this.$packagePromoRecommends.productSegments)!!,
            storeCluster: selectClusters,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            storeFormat: selectFormats,
// tslint:disable-next-line: no-non-null-assertion
            groupsOfProduct: LocalData.filterNumberArrays(this.$packagePromoRecommends.groupsOfProduct)!!,
// tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$packagePromoRecommends.subcategories),
            separateSubcategories: this.$packagePromoRecommends.separateSubcategories,
            separateClusters: this.$packagePromoRecommends.separateClusters,
            categoryStrategy: this.$packagePromoRecommends.categoryStrategy.value,
            calculationDepth: this.$packagePromoRecommends.calculationDepth,
            calculationDay: this.$packagePromoRecommends.calculationDay,
            manualPennies: this.$packagePromoRecommends.manualPennies,
            calcWithBatchNumber: false,
            thompsonSampling: false,
            applyOmnichannel: false,
            sendGeneralReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
            isFixPricePromo: this.$packagePromoRecommends.isFixPricePromo,
            useSkuRotation: this.moduleData.useSkuRotation,
            useFixedPrices: true,
        };
    }

    getSkuFilter(): SkuFilter & { storeClusters: number[] } {
      const productSegments = this.selectProductSegmentIdAndName.map((i) => i.segmentId).filter((it) => it !== null) as number[];

      const [selectSeasons, selectRegions, selectBuyerSegment, selectedSku, ctm, priceSegments] = this.selectData();

      return {
            category: null,
            storeCluster: null,
            storeClusters: this.moduleData.clusterIds.realValuesOrEmpty(),
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: this.moduleData.groupIds,
            categories: this.moduleData.categoryIds,
            storeFormat: this.moduleData.formatSelected,
            tradingId: this.moduleData.selectMarket.id,
            calculationDepth: this.moduleData.calculationDepth,
            calculationDay: this.periodForCalculatingEntered ? this.periodForCalculatingEntered as number : +this.moduleData.calculationDay,
            skuFilter: this.skuFilter,
            promoFilter: this.selectedPromoFilter,
            intervalOfUltimateElasticity: this.moduleData.intervalOfUltimateElasticity,
            groupOfProduct: null,
// tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.moduleData.subcategories)!!,
            discountPrise: false,
            promo: true,
            sortBySKU: this.sortBySKU,
            kvi: this.selectKVI,
            ctm,
            priceSegments,
            priceCorridor: this.moduleData.priceCorridor,
            changePriceCorridor: this.moduleData.changePriceCorridor,
            productsFilter: this.selectProducts,
            internalCodes: selectedSku,
            needCalculateSku: this.skuListWithCalculating,
            needCalculateSkuLastPricesOnly: this.needCalculateSkuLastPricesOnly,
            needCalculateSkuActualProfitabilityOnly: this.needCalculateSkuActualProfitabilityOnly,
            kviRecommendation: this.selectKVIRecommends,
            productSegments,
            keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOne,
            keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwo,
            recipeAttributes: this.selectRecipeAttributes,
            treatmentAttributes: this.selectTreatmentAttributes,
            alwaysCalculateProductSegments: true,
            countAtLastPurchasePrice: this.moduleData.countAtLastPurchasePrice,
            productRangeFilter: this.selectProductLine,
            correlation: this.moduleData.correlation,
        };
    }

    isValidDate(dateString: string, format: string = "YYYY-MM-DD") {
        return moment(dateString, format, true).isValid()
    }

    isValidPlanningPromoPeriod(): boolean {
        if (!this.isValidDate(this.itemToEdit.startDate as string)
            || !this.isValidDate(this.itemToEdit.endDate as string)
        ) {
            return false
        }

        const now = moment(new Date())
        const startDate = moment(this.itemToEdit.startDate as string)
        const endDate = moment(this.itemToEdit.endDate as string)

        // if (startDate.isBefore(now, 'days') || endDate.isBefore(startDate, 'days')) {
        return !endDate.isBefore(startDate, 'days');
    }

    async preCalc() {
        if (!this.isValidPlanningPromoPeriod()) {
          this.showError(this.$t('shared.parametersTab.invalidPlanPeriod') as string)
          return;
        }

        this.isCalculationButtonLoading = true;

        this.saveModuleItems();

        if (this.isNeedSaveParamsBeforeStartCalc) {
            await this.saveParams();
        }

        const data = this.getItemsFilter();

        this.httpPackageModuleItemsCalculationStart(this.moduleType, {
            ...data,
            saleId: this.moduleType === 'sales' ? this.itemToEdit.id : null,
            saleName: this.moduleType === 'sales' ? this.itemToEdit.name : null,
            promotionId: this.moduleType === 'promo' ? this.itemToEdit.id : null,
            promotionName: this.moduleType === 'promo' ? this.itemToEdit.name : null,
            minProfitability: this.itemToEdit.minMargin,
            maxProfitability: this.moduleData.maxMarginalProfit != null ? this.moduleData.maxMarginalProfit : 100,
            minDiscount: this.moduleType === 'promo' ? this.itemToEdit.minPromotionDiscount : this.itemToEdit.minSaleDiscount,
            maxDiscount: this.moduleType === 'promo' ? this.itemToEdit.maxPromotionDiscount : this.itemToEdit.maxSaleDiscount,
            stagesNumber: this.itemToEdit.stagesNumber,
            startDate: !!this.itemToEdit.startDate
                ? moment.utc(this.itemToEdit.startDate).startOf('day').valueOf()
                : null,
            endDate: !!this.itemToEdit.endDate
                ? moment.utc(this.itemToEdit.endDate).startOf('day').valueOf()
                : null,
          stageNumber: this.itemToEdit.stagesNumber,
          minMargin: this.itemToEdit.minMargin,

        } as ModuleItemCalculationStartParams)
            .then((r) => {
                    this.showInfo(this.$t('shared.parametersTab.calcStartedFor', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string, name: this.currentItem.name }) as string);
                    this.$log.debug('Create task', r.data);
                },
            )
            .catch(() => {
                this.showError(this.$t('shared.parametersTab.errorStartCalcFor', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string, name: this.currentItem.name }) as string);
            }).finally(() => {
                this.isCalculationButtonLoading = false;
            });
    }

    calcWithoutPromo() {
        const data = this.getItemsFilter();
        this.saveModuleItems();
        if (!data.calculateCommon) {
            this.recalculatingRegularPricesModalShow = true
        } else {
            this.httpGetCalcPromo(data)
                    .then((r) => {
                                this.showInfo(this.$t('shared.parametersTab.calcStarted') as string);
                                this.$log.debug('Create task', r.data);
                            },
                    )
                    .catch((ex) => {
                        this.showError(this.$t('shared.parametersTab.errorStartCalc') as string);
                    });
        }
    }

    calcWithRegularPrices() {
        const data = this.getItemsFilter();
        this.saveModuleItems();
        data.calculateCommon = true;
        this.httpGetCalcPromo(data)
                .then((r) => {
                            this.showInfo(this.$t('shared.parametersTab.calcStarted') as string);
                            this.$log.debug('Create task', r.data);
                        },
                )
                .catch((ex) => {
                    this.showError(this.$t('shared.parametersTab.errorStartCalc') as string);
                });
    }

    calcWithoutRegularPrices() {
        const data = this.getItemsFilter();
        this.saveModuleItems();
        this.httpGetCalcPromo(data)
                .then((r) => {
                            this.showInfo(this.$t('shared.parametersTab.calcStarted') as string);
                            this.$log.debug('Create task', r.data);
                        },
                )
                .catch((ex) => {
                    this.showError(this.$t('shared.parametersTab.errorStartCalc') as string);
                });
    }

    async saveParams() {
        await this.updateBasicItemParams();

        if (!this.isValidPlanningPromoPeriod()) {
          this.showError(this.$t('shared.parametersTab.invalidPlanPeriod') as string)
          return;
        }

        // Подгружаем конкурентов перед сохранением, на случай если забыли подгрузить через открытие списка SKU
        if (this.moduleData.competitorsCodes.length === 0) {
            const competitorFilter = this.getCompetitorsFilter();
            await this.httpLoadCompetitors(competitorFilter, -1, 0)
                    .then((data) => {
                        this.competitors = data.data;
                        this.moduleData.competitorsCodes = this.competitors.map((i) => {
                            return i.internalCode;
                        });
                    })
                    .catch((e) => {
                        this.showError(this.$t('shared.parametersTab.errorLoadCompetitorPrices') as string);
                    });
        }

        const filters: SaveModuleItemParamsFilter = {
            ...this.getItemsFilter(),
            minProfitability: this.itemToEdit.minMargin,
            maxProfitability: 100, // по умолчанию, т.к. неоткуда взять, maxMargin поля нет
            startDate: !!this.itemToEdit.startDate
                ? moment.utc(this.itemToEdit.startDate).startOf('day').valueOf()
                : null,
            endDate: !!this.itemToEdit.endDate
                ? moment.utc(this.itemToEdit.endDate).startOf('day').valueOf()
                : null,
            minMargin: this.itemToEdit.minMargin,
        };

        if (this.moduleType === 'promo') {
            filters.promotionId = this.itemToEdit.id;
            filters.promotionName = this.itemToEdit.name;
            filters.minDiscount = this.itemToEdit.minPromotionDiscount;
            filters.maxDiscount = this.itemToEdit.maxPromotionDiscount;
        } else {
            filters.saleId = this.itemToEdit.id;
            filters.saleName = this.itemToEdit.name;
            filters.minDiscount = this.itemToEdit.minSaleDiscount;
            filters.maxDiscount = this.itemToEdit.maxSaleDiscount;
            filters.stagesNumber = this.itemToEdit.stagesNumber;
            filters.stageNumber = this.itemToEdit.stagesNumber;
        }

        await this.httpSaveItemParamsFilter(this.moduleType, filters)
                .then((r) => {
                    this.$log.debug('Параметры сохранены', r.data);
                    this.showInfo(this.$t('shared.parametersTab.saveParamsSuccess') as string);

                    if (this.isNeedSaveParamsBeforeStartCalc) {
                        this.isNeedSaveParamsBeforeStartCalc = false;
                    }
                })
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorSaveCalcParams') as string);
                });
    }

    getCompetitorsFilter(): CompetitorsPriceFilter {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        return {
            discountPrise: this.moduleData.discountPrice,
            category: null,
            storeCluster: null,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: this.moduleData.groupIds,
            categories: this.moduleData.categoryIds,
            storeFormat: this.moduleData.formatSelected,
            tradingId: this.moduleData.selectMarket.id,
            calculationDepth: +this.moduleData.calculationDepth,
            calculationDay: this.periodForCalculatingEntered ? this.periodForCalculatingEntered as number : +this.moduleData.calculationDay,
            skuFilter: this.skuFilter,
            groupOfProduct: null,
// tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.moduleData.subcategories)!!,
            productSegments: LocalData.filterNumberArrays(this.moduleData.productSegments)!!,
            competitorsPricePeriod: this.moduleData.competitorsPricePeriod,
            promo: true,
            sortingField: null,
            isKviCartCompetitorsGrid: false,
        };
    }

    updatePriceCorridorAndSkuList() {
        this.priceCorridorInfo();
        this.saveModuleItems();
        this.saveCalc();
    }

    reloadSkuList() {
        this.isFiltersChanged = 1;
        this.needLoadSkuList = false;
    }

    clearFilters() {
        this.sortBySKU = -1;
        this.selectKVI = this.defaultFilterValue.value;
        this.selectKVIRecommends = this.defaultFilterValue.value;
        this.selectCTM = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
        this.selectSegmentPrice = [];
        this.selectProducts = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string}.value;
        this.selectedPromoFilter = {value: PromoFilterType.all, label: this.$t('shared.selectBox.all') as string}.value;
        this.segmentPriceOptions = [];
        this.selectProductSegmentIdAndName = [];
        this.productSegmentIdAndNameOptions = [];
        this.selectKeyCharacteristicOne = [];
        this.selectKeyCharacteristicTwo = [];
        this.selectRecipeAttributes = [];
        this.selectTreatmentAttributes = [];
        this.selectProductLine = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
    }

    clearFiltersInNewProductsTable() {
        this.sortingNewProductsBySKU = -1;
        this.selectKVIForNewProducts = this.defaultFilterValue.value;
        this.selectCTMForNewProducts = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
        this.selectSegmentPriceForNewProducts = [];
        this.segmentPriceOptionsForNewProducts = [];
        this.selectNewProductSegmentIdAndName = [];
        this.newProductSegmentIdAndNameOptions = [];
        this.selectKeyCharacteristicOneForNewProduct = [];
        this.selectKeyCharacteristicTwoForNewProduct = [];
        this.selectRecipeAttributesForNewProduct = [];
        this.selectTreatmentAttributesForNewProduct = [];
        this.refreshNewProductsTable()
    }

    calcButtonState(): boolean {
        if (this.moduleData.selectMarket != null) {
            const state = this.purchasePricePositive &&
                    this.calculationDepthValidate &&
                    this.calculationDayValidate &&
                    this.priceIncreaseLimitValidate &&
                    this.marginalPriceDifferenceValidate &&
                    this.marginalProfitabilityValidate &&
                    this.marginalProfitValidate &&
                    this.inputInterval &&
                    this.liftPositiveCheck &&
                    this.correlationCheck && this.competitorPriceControlParameterPcValidate;
            return !state;
        }
        return true;
    }

    calcButtonStateForSearchRecommends(): boolean {
        if (this.$packagePromoRecommends.selectMarket != null) {
            const state = this.isGroupsRecommendsSelected;
            return !state;
        }
        return true;
    }

    refreshPriceSegments() {
        if (!this.findAutomaticallyPriceSegments) {
            this.countPriceSegments = 1;
        }
    }

    hideSkuPanel() {
        this.showSku = false;
        this.clearFilters();
    }

    setCalcIndividConfig(config: ConfigMap<IndividualConfig>, sku: string, property: keyof IndividualConfig, value: number | SelectBox<any> | string) {
        if (!(sku in config)) {
            config[sku] = {};
        }
        config[sku][property] = value;
    }

    setPromoIndividConfig(config: ConfigMap<PromoIndividualConfig>, sku: string, property: keyof PromoIndividualConfig, value: number | SelectBox<any>) {
        if (!(sku in config)) {
            config[sku] = {};
        }
        if (typeof value === 'number' && Number.isNaN(value)) {
            config[sku][property] = null;
        } else {
            config[sku][property] = value;
        }
    }

    calcRegularPricesProfitability() {
        if (this.moduleData.selectMarket.id === -1 || !this.moduleData.categoryIds.length || this.regularPricesProfitability != null) {
            return;
        }
        this.isRegularPricesProfitabilityCalculated = true;
        if (this.showSku) {
            this.showSku = false
        }

        const filter = this.getSkuFilter();

        this.httpGetRegularPricesProfitability(filter)
                .then((number) => {
                    this.regularPricesProfitability = number.data;
                    this.isRegularPricesProfitabilityCalculated = false;
                })
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorCalcProfitability') as string);
                    this.isRegularPricesProfitabilityCalculated = false;
                });
    }

    calcActualProfitability() {
        if (this.moduleData.selectMarket.id === -1 || !this.moduleData.categoryIds.length || this.actualProfitability != null) {
            return;
        }
        this.isActualProfitabilityCalculated = true;
        if (this.showSku) {
            this.showSku = false
        }

        const filter = this.getSkuFilter()
        this.httpGetActualProfitability(filter)
                .then((number) => {
                    this.actualProfitability = number.data;
                    this.isActualProfitabilityCalculated = false;
                })
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorCalcActualProfitability') as string);
                    this.isActualProfitabilityCalculated = false;
                })
    }

    onTabsChanged(evt: string) {
        if (evt === "systemTab") {
            (this.$refs.competitorsListRef as any).activate();
        } else {
            (this.$refs.competitorsListRef as any).deactivate();
        }
    }

    private priceCorridorInfo() {
        if (!this.moduleData.changePriceCorridor) {
            this.hideSkuPanel();
            return;
        }
        if (this.moduleData.selectMarket.id === -1 || !this.moduleData.categoryIds.length) {
            return;
        }
        this.isPriceCorridorCalculated = true;

        const filters = this.getItemsFilter();
        this.httpPostPriceCorridor(filters)
                .then((r) => {
                            this.moduleData.priceCorridor = r.data;
                            this.isPriceCorridorCalculated = false;
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorLoadPriceCorridor') as string);
                    this.$log.error('Error occurred [load price corridor]', e);
                    this.isPriceCorridorCalculated = false;
                });
    }

    private refreshNewProductsTable() {
        const oldRefreshId = this.refreshNewProductsListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshNewProductsListId === timeoutId) {
                this.newProductsPagination.current = 1;
                const newProductsTableInPanel = this.$refs.newProductsTableRef as any;
                if (typeof newProductsTableInPanel !== 'undefined') {
                    newProductsTableInPanel.refresh();
                }
                this.refreshNewProductsListId = -1;
            }
        }, 250);
        this.refreshNewProductsListId = timeoutId;
    }

    private refreshCdRecommends() {
        this.selectProductsTypeForRecommends = this.selectProductsForCdRecommends.value;
        this.kviValueForRecommends = this.selectKVIForCdRecommends.value;
        this.ctmValueForRecommends = this.selectCTMForCdRecommends.value === 'all' ? null : this.selectCTMForCdRecommends.value;
        this.sortBySKUValueForRecommends = this.sortBySKUForCdRecommends;
        this.segmentPriceValueForRecommends = this.selectCdRecommendsSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        this.refreshCdRecommendsTable();
    }

    private refreshIgRecommends() {
        this.selectProductsTypeForRecommends = this.selectProductsForIgRecommends.value;
        this.kviValueForRecommends = this.selectKVIForIgRecommends.value;
        this.ctmValueForRecommends = this.selectCTMForIgRecommends.value === 'all' ? null : this.selectCTMForIgRecommends.value;
        this.sortBySKUValueForRecommends = this.sortBySKUForIgRecommends;
        this.segmentPriceValueForRecommends = this.selectIgRecommendsSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        this.refreshIgRecommendsTable();
    }

    private refreshCdRecommendsTable() {
        const oldRefreshId = this.refreshCdRecommendsId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshCdRecommendsId === timeoutId) {
                this.skuRecommendsListCurrentPage = 1;
                const recommendsCdSKU = this.$refs.recommendsCdSKU as any;
                if (typeof recommendsCdSKU !== 'undefined') {
                    recommendsCdSKU.refresh();
                }
                this.refreshCdRecommendsId = -1;
            }
        }, 250);
        this.refreshCdRecommendsId = timeoutId;
        this.isFiltersChangedForRecommends = 1;
    }

    private refreshIgRecommendsTable() {
        const oldRefreshId = this.refreshIgRecommendsId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshIgRecommendsId === timeoutId) {
                this.skuRecommendsListCurrentPage = 1;
                const recommendsIgSKU = this.$refs.recommendsIgSKU as any;
                if (typeof recommendsIgSKU !== 'undefined') {
                    recommendsIgSKU.refresh();
                }
                this.refreshIgRecommendsId = -1;
            }
        }, 250);
        this.refreshIgRecommendsId = timeoutId;
        this.isFiltersChangedForRecommends = 1;
    }

    private loadCommonParams(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpFindModuleItemParams, this.moduleType, findFilterParams)
                    .then((r) => {
                        if (!r.ignore) {
                            const resp = r.response;

                            if (resp.status === 200) {
                                const filter = resp.data.filters;

                                if (this.moduleType === 'promo') {
                                    this.applyPromotionsFilters(this.$promotions as any, filter);
                                } else {
                                    this.applySalesFilters(this.$sales as any, filter);
                                }
                            } else if (resp.status === 204) {
                                this.isNeedSaveParamsBeforeStartCalc = true;
                            }
                        }

                        resolve(!r.ignore);
                    })
                    .catch((e) => {
                        reject(e);
                    });
        });
    }

    get calcButt(): boolean {
        return this.calcButtonState();
    }

    get calcButtRecommends(): boolean {
        return this.calcButtonStateForSearchRecommends();
    }

    get purchasePricePositive(): boolean {
        return this.moduleData.purchasePrice == null || this.moduleData.purchasePrice > 0;
    }

    get calculationDepthValidate(): boolean {
        return this.moduleData.calculationDepth * 7 >= this.moduleData.calculationDay;
    }

    get promoPriceCalculationDepthValidate(): boolean {
      return this.moduleData.calculationDepth * 7 >= this.moduleData.calculationDay;
    }

    get promoRecommendsCalculationDepthValidate(): boolean {
        return this.$packagePromoRecommends.calculationDepth * 7 >= this.$packagePromoRecommends.calculationDay;
    }

    get calculationDayValidate(): boolean {
        return this.moduleData.calculationDay > 0;
    }

    get promoRecommendsCalculationDayValidate(): boolean {
        return this.$packagePromoRecommends.calculationDay > 0;
    }

    get priceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.moduleData.priceIncreaseLimit;
        return priceIncreaseLimit.toString() !== '' && priceIncreaseLimit >= 0;

    }

    get marginalPriceDifferenceValidate(): boolean {
        if (this.moduleData.marginalPriceDifference != null) {
            return this.moduleData.marginalPriceDifference >= 0 && this.moduleData.marginalPriceDifference <= 100;
        }
        return false;
    }

    get marginalProfitabilityValidate(): boolean {
        const marginalProfitability = this.moduleData.marginalProfitability;
        if (marginalProfitability < 0) {
            this.marginalSkuErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
        } else {
            this.marginalSkuErrorText = ''
        }
        return marginalProfitability < 100;
    }

    get competitorsMinProfitValidate(): boolean {
        const competitorsMinimumProfit = this.moduleData.competitorsMinimumProfit;
        return competitorsMinimumProfit.toString() !== '' && competitorsMinimumProfit >= -50 && competitorsMinimumProfit <= 500;
    }

    get competitorsMinProfitPromoValidate(): boolean {
      const competitorsMinimumProfitPromo = this.moduleData.competitorsMinimumProfitPromo;
      return competitorsMinimumProfitPromo.toString() !== '' && competitorsMinimumProfitPromo >= -50 && competitorsMinimumProfitPromo <= 500;
    }

    get priceGapValidate(): boolean {
        const priceGap = this.moduleData.priceGap;
        return priceGap.toString() !== '' && priceGap >= 0;
    }

    get priceGapCtmPcValidate(): boolean {
        const priceGapCtm = this.moduleData.priceGapCtmPc;
        return priceGapCtm !== null && priceGapCtm.toString() !== '' && priceGapCtm >= 0 && priceGapCtm <= 100;
    }

    get minProfitKVIValidate(): boolean {
        const minProfitKvi = this.moduleData.minProfitKVI;
        return minProfitKvi.toString() !== '' && minProfitKvi >= -50 && minProfitKvi <= 500;
    }

    get marginalProfitValidate(): boolean {
        const marginalProfit = this.moduleData.marginalProfit;
        if (marginalProfit < 0) {
            this.marginalErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
        } else {
            this.marginalErrorText = ''
        }
        return marginalProfit.toString() !== '' && marginalProfit < 100;
    }

    get maxMarginalProfitValidate(): boolean {
        const maxMarginalProfit = this.moduleData.maxMarginalProfit != null ? this.moduleData.maxMarginalProfit : 100;
        const marginalProfit = this.moduleData.marginalProfit != null ? this.moduleData.marginalProfit : 0;
        if (maxMarginalProfit < marginalProfit) {
            this.maxMarginalErrorText = this.$t('shared.parametersTab.maxProfitMustBeGteMin') as string
        } else if (maxMarginalProfit > 100) {
            this.maxMarginalErrorText = this.$t('shared.parametersTab.maxProfitMustBeLte100') as string
        } else {
            this.maxMarginalErrorText = ''
        }
        return maxMarginalProfit >= marginalProfit && maxMarginalProfit <= 100;
    }

    get maxProfitKVIValidate(): boolean {
        const maxProfitKVI = this.moduleData.maxProfitKVI != null ? this.moduleData.maxProfitKVI : 100;
        const minProfitKVI = this.moduleData.minProfitKVI != null ? this.moduleData.minProfitKVI : 0;
        return maxProfitKVI >= minProfitKVI && maxProfitKVI <= 100;
    }

    get competitorsMaximumProfitPromoValidate(): boolean {
        const competitorsMaximumProfitPromo = this.moduleData.competitorsMaximumProfitPromo != null ? this.moduleData.competitorsMaximumProfitPromo : 100;
        const competitorsMinimumProfitPromo = this.moduleData.competitorsMinimumProfitPromo != null ? this.moduleData.competitorsMinimumProfitPromo : 0;
        if (competitorsMaximumProfitPromo < competitorsMinimumProfitPromo) {
            this.competitorsMaximumProfitPromoErrorText = this.$t('shared.parametersTab.maxProfitMustBeGteMin') as string
        } else if (competitorsMaximumProfitPromo > 100) {
            this.competitorsMaximumProfitPromoErrorText = this.$t('shared.parametersTab.maxProfitMustBeLte100') as string
        } else {
            this.competitorsMaximumProfitPromoErrorText = ''
        }
        return competitorsMaximumProfitPromo >= competitorsMinimumProfitPromo && competitorsMaximumProfitPromo <= 100;
    }

    get minPromoPriceValidate(): boolean {
        const minPromoPrice = this.moduleData.minPromoPrice;
        return (!minPromoPrice && minPromoPrice !== 0) || minPromoPrice > 0;
    }

    get globalIndividualMarginalProfitValidate(): boolean {
        const marginalProfit = this.globalIndividualMarginalProfitability;
        if (marginalProfit !== null) {
            if (marginalProfit < 0) {
                this.globalIndividualMarginalErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
            } else {
                this.globalIndividualMarginalErrorText = ''
            }
            this.globalIndividualMarginalBlockButton = marginalProfit > 100;
            return marginalProfit < 100;
        }
        return true;
    }

    get globalNewProductIndividualMarginalProfitValidate(): boolean {
        const marginalProfit = this.globalIndividualNewProductMarginalProfitability;
        if (marginalProfit !== null) {
            if (marginalProfit < 0) {
                this.globalNewProductIndividualMarginalErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
            } else {
                this.globalNewProductIndividualMarginalErrorText = ''
            }
            this.globalNewProductIndividualMarginalBlockButton = marginalProfit > 100;
            return marginalProfit < 100;
        }
        return true;
    }

    get globalIndividualPeriodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.globalIndividualPeriodPriceIncreaseLimit;
        if (periodPriceIncreaseLimit == null) {
            return true;
        } else {
            this.globalIndividualPeriodPriceIncreaseLimitBlockButton = periodPriceIncreaseLimit < 0;
            return periodPriceIncreaseLimit >= 0;
        }
    }

    get globalIndividualPriceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.globalIndividualPriceIncreaseLimit;
        if (priceIncreaseLimit == null) {
            return true;
        } else {
            this.globalIndividualPriceIncreaseLimitBlockButton = priceIncreaseLimit < 0 || priceIncreaseLimit > 100;
            return priceIncreaseLimit >= 0 && priceIncreaseLimit < 100;
        }
    }

    get priceChangeLimitValidate(): boolean {
        const priceChangeLimit = this.moduleData.priceChangeLimit;
        return priceChangeLimit >= 0 && priceChangeLimit < 100;
    }

    get countPriceSegmentsValidate(): boolean {
        const countSegments = this.countPriceSegments;
        return countSegments.toString() !== '' && countSegments > 0;
    }

    get promoQuoteValidate(): boolean {
        const promoQuoteValue = this.moduleData.promoQuoteValue;
        return promoQuoteValue != null && promoQuoteValue > 0;
    }

    get periodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.moduleData.periodPriceIncreaseLimit;
        return periodPriceIncreaseLimit.toString() !== '' && periodPriceIncreaseLimit >= 0;
    }

    get inputInterval(): boolean {
        const lowerI = this.moduleData.intervalOfUltimateElasticity.lower.toString();
        const upperI = this.moduleData.intervalOfUltimateElasticity.upper.toString();
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get inputIntervalCorrelation(): boolean {
        const lowerI = this.moduleData.intervalOfCorrelationElasticity.lower.toString();
        const upperI = this.moduleData.intervalOfCorrelationElasticity.upper.toString();
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get inputIntervalP(): boolean {
        if (this.moduleData.selectMarket.id === -1 || !this.moduleData.categoryIds.length) {
            return false;
        }
        const lowerI = this.moduleData.priceCorridor.min.toString();
        const upperI = this.moduleData.priceCorridor.max.toString();
        if (this.moduleData.priceCorridor.min >= this.moduleData.priceCorridor.max || this.moduleData.priceCorridor.min >= this.moduleData.priceCorridor.max) {
            return false;
        }
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }

        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get liftPositiveCheck(): boolean {
        return this.moduleData.lift >= 0;
    }

    get globalLiftPositiveCheck(): boolean {
        if (this.globalIndividualLift !== null) {
            this.globalLiftBlockButton = this.globalIndividualLift < 0 || this.globalIndividualLift > 100;
            return this.globalIndividualLift >= 0 && this.globalIndividualLift <= 100;
        }
        return true;
    }

    get globalNewProductLiftPositiveCheck(): boolean {
        if (this.globalIndividualNewProductLift !== null) {
            this.globalNewProductLiftBlockButton = this.globalIndividualNewProductLift < 0 || this.globalIndividualNewProductLift > 100;
            return this.globalIndividualNewProductLift >= 0 && this.globalIndividualNewProductLift <= 100;
        }
        return true;
    }

    get highElasticityCheck(): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const highElasticity = this.moduleData.highElasticity.toString();
        this.$log.debug(highElasticity.length > 0, numberPattern.test(highElasticity));
        return numberPattern.test(highElasticity);
    }

    get correlationCheck(): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const correlation = this.moduleData.correlation.toString();
        if (correlation.length === 0 || !numberPattern.test(correlation)) {
            return false;
        }
        const cor = parseFloat(correlation);
        return 1 >= cor && cor >= -1;
    }

    get isDisabledPriceBorder(): boolean {
        return !this.moduleData.changePriceCorridor;
    }

    get paramsSumXYZ(): boolean {
        const x = this.moduleData.xyzParams.x;
        const y = this.moduleData.xyzParams.y;
        const z = this.moduleData.xyzParams.z;
        if (x.toString().length === 0 || y.toString().length === 0 || z.toString().length === 0) {
            return false;
        }
        const sum = (x + y + z);
        return sum === 100;
    }

    get paramsSum(): boolean {
        const u = this.moduleData.uvwParams.u;
        const v = this.moduleData.uvwParams.v;
        const w = this.moduleData.uvwParams.w;
        if (u.toString().length === 0 || v.toString().length === 0 || w.toString().length === 0) {
            return false;
        }
        const sum = (+v + +u + +w);
        return sum === 100;
    }

    get competitorsPricesValidate(): boolean {
        const competitorsP = this.moduleData.competitorsPrices.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

        return numberPattern.test(competitorsP);
    }

    get percentageOfRecommendsKviValidate(): boolean {
        const kviRecommends = this.moduleData.percentageOfRecommendsKviCount.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);
        return numberPattern.test(kviRecommends);
    }

    get isSubcategorySelected(): boolean {
        const subcategories = LocalData.filterNumberArrays(this.moduleData.subcategories);
        return subcategories != null && subcategories.length!! > 0;
    }

    get isSubcategorySelectedRecommends(): boolean {
        const subcategories = LocalData.filterNumberArrays(this.$packagePromoRecommends.subcategories);
        return subcategories != null && subcategories.length!! > 0;
    }


    get isSubcategorySelectedForRoundingRules(): boolean {
        const subcategories = LocalData.filterNumberArrays(this.$roundingRules.subcategories);
        return subcategories != null && subcategories.length!! > 0;
    }

    get isGroupSelected(): boolean {
// tslint:disable-next-line: no-non-null-assertion
        return !!this.moduleData.groupIds.length;
    }

    get isGroupSelectedForRoundingRules(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$roundingRules.groupOfProduct != null && this.$roundingRules.groupOfProduct!! > 0;
    }

    get isGroupsRecommendsSelected(): boolean {
        const groups = LocalData.filterNumberArrays(this.$packagePromoRecommends.groupsOfProduct);
        return groups != null && groups.length > 0;
    }

    get competitorPriceControlParameterPcValidate(): boolean {
        return this.moduleData.competitorPriceControlParameterPc.toString() !== '' && this.moduleData.competitorPriceControlParameterPc > 0 && this.moduleData.competitorPriceControlParameterPc <= 100;
    }

    get competitorPriceControlParameterPcPromoValidate(): boolean {
      return this.moduleData.competitorPriceControlParameterPcPromo.toString() !== ''
          && this.moduleData.competitorPriceControlParameterPcPromo > 0
          && this.moduleData.competitorPriceControlParameterPcPromo <= 100;
    }

    get daysToPriceChangeStartValidateModule(): boolean | null {
        if (this.moduleData.daysToPriceChangeStart == null || this.moduleData.daysToPriceChangeStart === 0) {
            return null;
        }
        return this.moduleData.daysToPriceChangeStart > 0;
    }

    get daysToPriceChangeFinishValidateModule(): boolean | null {
        if (this.moduleData.daysToPriceChangeFinish == null || this.moduleData.daysToPriceChangeFinish === 0) {
            return null;
        }
        if (this.moduleData.daysToPriceChangeFinish <= 0) {
            return false;
        }
        if (this.moduleData.daysToPriceChangeStart != null && this.moduleData.daysToPriceChangeStart > 0) {
            return this.moduleData.daysToPriceChangeFinish >= this.moduleData.daysToPriceChangeStart;
        }
        return true;
    }

    setNonNegativeInteger(input: string): string {
        const parsed = parseInt(input, 10);
        if (isNaN(parsed)) {
            return input;
        }
        if (parsed < 0) {
            return '0';
        }
        return parsed.toString();
    }

    get minMarginValidate(): boolean {
        return !!((this.itemToEdit.minMargin || this.itemToEdit.minMargin === 0) && this.itemToEdit.minMargin >= -100 && this.itemToEdit.minMargin <= 100);
    }

    get minSaleDiscountValidate(): boolean {
        return !!((this.itemToEdit.minSaleDiscount || this.itemToEdit.minSaleDiscount === 0) && this.itemToEdit.minSaleDiscount >= 0 && this.itemToEdit.minSaleDiscount <= 100);
    }

    get minPromotionDiscountValidate(): boolean {
        return !!((this.itemToEdit.minPromotionDiscount || this.itemToEdit.minPromotionDiscount === 0) && this.itemToEdit.minPromotionDiscount >= 0 && this.itemToEdit.minPromotionDiscount <= 100);
    }

    get maxSaleDiscountValidate(): boolean {
        return !!((this.itemToEdit.maxSaleDiscount || this.itemToEdit.maxSaleDiscount === 0) && this.itemToEdit.maxSaleDiscount >= 0 && this.itemToEdit.maxSaleDiscount <= 100);
    }

    get maxPromotionDiscountValidate(): boolean {
        return !!((this.itemToEdit.maxPromotionDiscount || this.itemToEdit.maxPromotionDiscount === 0) && this.itemToEdit.maxPromotionDiscount >= 0 && this.itemToEdit.maxPromotionDiscount <= 100);
    }

    private get isGroupsSelected(): boolean {
        return !!(this.entityFilters.groupIds.length && this.entityFilters.groupIds[0] !== 0);
    }

    private get isCategoriesSelected(): boolean {
        return !!(this.entityFilters.categoryIds.length && this.entityFilters.categoryIds[0] !== 0);
    }

    private get isFormatSelected(): boolean {
        return !!this.entityFilters.formatId;
    }

    private get isRegionsSelected(): boolean {
        return !!(this.entityFilters.regionIds.length && this.entityFilters.regionIds[0] !== 0);
    }

    private get isRequiredFiltersNotSelected(): boolean {
        return !this.isGroupsSelected || !this.isFormatSelected;
    }

    private returnToItemsList() {
        this.$emit('to-items-list');
    }

    private setNonNegative(input: string): string {
        const parsed = parseFloat(input);
        if (isNaN(parsed)) {
            return input;
        }
        if (parsed < 0) {
            return `${parsed * -1}`;
        } else {
            return input;
        }
    }

    private getMessage(form: string, field: string): string | null {
        if (!this.formErrors.hasOwnProperty(form)) {
            return null;
        }

        if (!this.formErrors[form].hasOwnProperty(field)) {
            return null;
        }
        return this.formErrors[form][field].message;
    }

    private handleHttpError(err: any) {
        if (err && err.hasOwnProperty('response') && err.response != null) {
            if (err.response.data && err.response.data.errors && err.response.data.errors.length) {
                const errors = err.response.data as IErrors;
                this.renderErrors('updateItem', errors);
            } else if (err.response.data && typeof (err.response.data) === 'string') {
                this.showError(err.response.data);
                this.$log.error('Error occurred while save module item - ' + this.moduleType, err);
            } else {
                this.showError(this.$t('shared.parametersTab.errorSaveItemOnSave', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string }) as string);
                this.$log.error('Error occurred while save module item - ' + this.moduleType, err);
            }
        } else {
            this.showError(this.$t('shared.parametersTab.errorSaveItemOnSaveExcl', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string }) as string);
            this.$log.error('Error occurred while save module item - ' + this.moduleType, err);
        }
    }

    private renderErrors(form: string, errors: IErrors) {
        this.hideFormErrors(form)
        this.showFormError = true;
        errors.errors.forEach((e) => {
            this.formErrors[form][e.property] = e;
        });
    }

    private hideFormErrors(form: string) {
        this.formErrors[form] = {};
        this.showFormError = false;
    }

    private get allowToSave(): boolean {
        const minDiscountValidate: boolean = this.moduleType === 'promo' ? this.minPromotionDiscountValidate : this.minSaleDiscountValidate;
        const maxDiscountValidate: boolean = this.moduleType === 'promo' ? this.maxPromotionDiscountValidate : this.maxSaleDiscountValidate;

        return !!(this.itemToEdit.name && this.itemToEdit.type && this.itemToEdit.status && this.itemToEdit.startDate && this.itemToEdit.endDate)
            && this.priceDecreaseLimitValidate && this.minPromoPriceValidate && this.minMarginValidate
            && minDiscountValidate && maxDiscountValidate;
    }

    private setParamsVerticalTabsHeight() {
        this.parametersTabsHeight = (this.$refs.parametersTabs as Vue).$el.scrollHeight * 1.1 + 'px';
    }

    private get isCalcButtonDisabled(): boolean {
        const minDiscountValidate: boolean = this.moduleType === 'promo' ? this.minPromotionDiscountValidate : this.minSaleDiscountValidate;
        const maxDiscountValidate: boolean = this.moduleType === 'promo' ? this.maxPromotionDiscountValidate : this.maxSaleDiscountValidate;

        return !this.itemToEdit.id || !this.minMarginValidate
        || !minDiscountValidate || !maxDiscountValidate || this.currentItem.status === 'STOPPED' && this.isCalculationButtonLoading;
        // возможно и || !this.moduleData.selectCoefficent.value.enum;
    }
    private get isSaveButtonDisabled(): boolean {
        return !this.allowToSave || this.itemToEdit.status === 'STOPPED';
    }

    private get isItemEditStopped(): boolean {
        return this.itemToEdit.status === 'STOPPED';
    }

    handlePeriodForCalculatingChange(value: number | string) {
        this.periodForCalculatingEntered = value !== '' ? Number(value) : value;
    }

    handlePeriodForCalculatingFocusOut() {
        if (this.periodForCalculatingEntered === '') {
            this.periodForCalculatingEntered = null;
        }
    }

    disabledDatepickerDate(current: Moment, data: any, property: string) {
        if (current && current < moment().startOf('day')) return true;

        if (property === 'startDate') {
            if (data.endDate) {
                return current && current > moment(data.endDate).endOf('day')
            }
        }

        if (property === 'endDate') {
            if (data.startDate) {
                return current && current < moment(data.startDate).startOf('day')
            }
        }

        return false;
    }

    valueInRange(input: string, fromNumber: number, toNumber: number): number {
        const inputValue = isNaN(parseFloat(input)) ? 0 : parseFloat(input);

        if (inputValue > toNumber) {
            return toNumber;
        } else if (inputValue < fromNumber) {
            return fromNumber;
        } else {
            return inputValue;
        }
    }

    handleMaxSaleDiscountValueChanged() {
        if (this.itemToEdit.minSaleDiscount && isNumber(this.itemToEdit.maxSaleDiscount)
            && this.itemToEdit.maxSaleDiscount < this.itemToEdit.minSaleDiscount) {
            this.itemToEdit.minSaleDiscount = this.itemToEdit.maxSaleDiscount;
        }
    }

    handleMaxPromotionDiscountValueChanged() {
        if (this.itemToEdit.minPromotionDiscount && isNumber(this.itemToEdit.maxPromotionDiscount)
            && this.itemToEdit.maxPromotionDiscount < this.itemToEdit.minPromotionDiscount) {
            this.itemToEdit.minPromotionDiscount = this.itemToEdit.maxPromotionDiscount;
        }
    }

    private getTaskInfo(taskType: EntityFilterKeys): GetTaskInfo {
        return {
            type: taskType,
            tradingId: this.moduleData.selectMarket.id,
            groups: this.entityFilters.groupIds,
            categories: this.entityFilters.categoryIds,
            subcategory: this.entityFilters.subcategoryId && this.entityFilters.subcategoryId !== 0 ? [this.entityFilters.subcategoryId] : null,
            storeFormat: this.entityFilters.formatId && this.entityFilters.formatId !== 0 ? [this.entityFilters.formatId] : null,
            storeRegion: this.entityFilters.regionIds,
            storeCluster: this.entityFilters.clusterIds,
            productSegments: null,
            segments: null,
            byReports: false,
        }
    }

    fetchEntityMaskSelectOptions(type: EntityFilterKeys, refValue: string) {
        this.$nextTick(() => {
            if (this.$refs[refValue]) {
                (this.$refs[refValue] as any).toggleLoading(true);
            }
        });

        this.httpGetProductInfo(this.getTaskInfo(type))
            .then(data => {
                const options = data.data ? data.data[ProductInfoResponseProperty[type]] : [];

                if (options.length) {
                    this.entityMaskOptions[this.entityMaskOptionPropertyNames[type] as keyof EntityMaskOptions] = [
                        { value: 0, label: this.$t('shared.selectBox.all') as string },
                        ...options.map((i) => {
                            return { value: i.id, label: i.name };
                        }),
                    ];
                } else {
                    this.entityMaskOptions[this.entityMaskOptionPropertyNames[type] as keyof EntityMaskOptions] = [{ value: 0, label: this.$t('shared.selectBox.all') as string }];
                }
            })
            .catch(() => {
                this.entityMaskOptions[this.entityMaskOptionPropertyNames[type] as keyof EntityMaskOptions] = [{ value: 0, label: this.$t('shared.selectBox.all') as string }];

                this.showError(this.$t('shared.parametersTab.errorLoadSelectOptions') as string);
            }).finally(() => {
                if (this.$refs[refValue]) {
                    (this.$refs[refValue] as any).toggleLoading(false);
                }
            });
    }

    updateEntityFiltersData(type: EntityFilterKeys) {
        const defaultMultiSelectValue: number[] = this.defaultIntSelectBox.map(i => i.value);

        switch (type) {
            case TaskInfoFilterType.group:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.category, 'entityCategoriesSelectRef');
                this.entityFilters.categoryIds = [...defaultMultiSelectValue];

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.subcategory, 'entitySubcategorySelectRef');
                this.entityFilters.subcategoryId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
                this.entityFilters.formatId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionsSelectRef');
                this.entityFilters.regionIds = [...defaultMultiSelectValue];

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');
                this.entityFilters.clusterIds = [...defaultMultiSelectValue];

                break;
            case TaskInfoFilterType.category:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.subcategory, 'entitySubcategorySelectRef');
                this.entityFilters.subcategoryId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
                this.entityFilters.formatId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionsSelectRef');
                this.entityFilters.regionIds = [...defaultMultiSelectValue];

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');
                this.entityFilters.clusterIds = [...defaultMultiSelectValue];

                break;
            case TaskInfoFilterType.subcategory:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
                this.entityFilters.formatId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionsSelectRef');
                this.entityFilters.regionIds = [...defaultMultiSelectValue];

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');
                this.entityFilters.clusterIds = [...defaultMultiSelectValue];

                break;
            case TaskInfoFilterType.format:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionsSelectRef');
                this.entityFilters.regionIds = [...defaultMultiSelectValue];

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');
                this.entityFilters.clusterIds = [...defaultMultiSelectValue];

                break;
            case TaskInfoFilterType.region:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');
                this.entityFilters.clusterIds = [...defaultMultiSelectValue];

                break;
        }
    }

    handleEntityFilterChanged(value: number[] | number, type: EntityFilterKeys) {
        if (Array.isArray(value)) {
            if (!!value.length && !LocalData.compareTwoArrays(value, this.entityFilters[this.entityFiltersPropertyNames[type] as keyof EntityFilters] as number[])) {
                this.entityFilters[this.entityFiltersPropertyNames[type] as keyof EntityFilters] = value.realValuesOrEmpty();

                this.updateEntityFiltersData(type);
            }
        } else {
            if (value !== this.entityFilters[this.entityFiltersPropertyNames[type] as keyof EntityFilters]) {
                this.entityFilters[this.entityFiltersPropertyNames[type] as keyof EntityFilters] = value;

                this.updateEntityFiltersData(type);
            }
        }
    }
}
